import React, { Component } from 'react';
import { Container,
    Card,
    CardBody,
    Row,
    Col,
    Spinner,
    Modal,
    ModalHeader,
    ModalBody,
    FormGroup,
    Button,
    InputGroup,
    Label,
    TabContent,
    Nav, 
    TabPane,
    NavLink,
    NavItem,
    InputGroupAddon } from "reactstrap";

import {
    WhatsappShareButton,
    WhatsappIcon,
    } from "react-share";
import { EditorState, convertToRaw } from 'draft-js';
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from 'draftjs-to-html';

import { validateToken } from '../../helpers/jwt-token-access/accessToken'
import classnames from "classnames";
import ColorPicker from "@vtaits/react-color-picker";
import "@vtaits/react-color-picker/dist/index.css";
import "flatpickr/dist/themes/material_blue.css"

import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";
import Moment from 'moment';
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

import { isEmpty } from "lodash";

import { BaseUrl } from "../../helpers/Baseurl"
import { getDifferenceInDays, createSlugfromName, calculateDistance } from '../../helpers/methods';
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import "./itineraryDetailstyle.css"

// Add print-specific styles
// const printStyles = `
// @media print {
//   @page {
//     size: A4;
//     margin: 0.5cm;
//   }
  
//   body {
//     -webkit-print-color-adjust: exact !important;
//     print-color-adjust: exact !important;
//     color-adjust: exact !important;
//     font-size: 12px !important;
//     justify-content: flex-start !important;
//   }
       
  
//   .page-content {
//     padding: 0 !important;
//     margin: 0 !important;
//   }
  
//   .pagebreak {
//     page-break-before: always !important;

//     clear: both !important;
//   }
  
//   .no-print, .no-print * {
//     display: none !important;
//   }
  
//   .print-only {
//     display: block !important;
//   }
  
//   .timeline-box {
//     break-inside: avoid !important;
//   }
  
//   .timeline-date {
//     background-color: #fcb92c !important;
//     color: black !important;
//     -webkit-print-color-adjust: exact !important;
//     print-color-adjust: exact !important;
//   }
  
//   .card {
//     border: 1px solid #ddd !important;
//     box-shadow: none !important;
//   }
  
//   .timeline-image img {
//     max-height: 200px !important;
//     width: auto !important;
//     max-width: 100% !important;
//   }
  
//   .scrollmenu {
//     overflow: visible !important;
//     white-space: normal !important;
//   }
  
//   .scrollmenu a {
//     display: inline-block !important;
//     margin-right: 10px !important;
//   }
  
//   .scrollmenu img {
//     max-width: 80px !important;
//     height: auto !important;
//   }
  
//   h1, h2, h3, h4, h5, h6 {
//     page-break-after: avoid !important;
//   }
  
//   p, h2, h3 {
//     orphans: 3 !important;
//     widows: 3 !important;
//   }
  
//   .timeline-left .timeline-box {
//     margin-left: 0 !important;
//   }
  
//   .timeline-item .timeline-box {
//     margin-right: 0 !important;
//   }
  
//   .timeline::before {
//     display: none !important;
//   }
  
//   .timeline-icon {
//     display: none !important;
//   }
  
//   .time-show-btn {
//     page-break-before: always !important;
//     margin-top: 20px !important;
//   }

  
//   .time-show-btn .btn {
//     border: none !important;
//     background-color: #556ee6 !important;
//     color: white !important;
//     -webkit-print-color-adjust: exact !important;
//     print-color-adjust: exact !important;
//   }
  
//   .Tophead, #top, #top-btn {
//     display: none !important;
//   }
  
//   .print-header {
//     display: flex !important;
//     justify-content: space-between !important;
//     align-items: center !important;
//     margin-bottom: 20px !important;
//   }
  
//   .print-logo {
//     max-width: 150px !important;
//   }
  
//   .print-title {
//     font-size: 24px !important;
//     font-weight: bold !important;
//     text-align: center !important;
//     flex-grow: 1 !important;
//   }
  
//   .print-date {
//     font-size: 12px !important;
//     text-align: right !important;
//   }
  
//   .print-footer {
//     position: fixed !important;
//     bottom: 0 !important;
//     width: 100% !important;
//     text-align: center !important;
//     font-size: 10px !important;
//     padding: 5px 0 !important;
//     border-top: 1px solid #ddd !important;
//   }
  
//   .print-page-number:after {
//     content: counter(page) !important;
//   }
  
//   .commentHTMLData img {
//     max-width: 100% !important;
//     height: auto !important;
//   }
// }
// `;

const printStyles = `
@media print {
  @page {
    size: A4;
    margin: 0.5cm;
  }

  /* Base styles for desktop (unchanged) */
  body {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
    color-adjust: exact !important;
    font-size: 16px !important;
    justify-content: flex-start !important;
  }
  
  .page-content {
    padding: 0 !important;
    margin: 0 !important;
  }

  .time-show-btn {
    font-size: 16px !important;
  }
  
  .pagebreak {
    page-break-before: avoid !important;
    page-break-after: always !important;
    page-break-inside: avoid !important;
    clear: both !important;
  }

  
    .pagebreakavoid
    {
    page-break-before: avoid !important;
    page-break-after: avoid !important;
    page-break-inside: avoid !important;
    clear: both !important;
  }
  
  .vehicle-imageAlign {
    justify-content: left !important;
    height: 95px;
  }
  .vehicle-image {
    min-height: 90px !important;
  }
.backcolor{
background-color: #f1f5f7;
}
.alignrightpage{
  margin-left: -45px;
  width:120% !important;
}
  .paymentandTNCalign{
    margin-left: -45px;
  width:120% !important;
  }
  .hotel-imageAlign {
    justify-content: left !important;
  }
  .hotel-image {
    min-height: 90px !important;
  }
  .hotel-name {
    text-align: left !important;
  }
  .hotel-heading {
    text-align: left !important;
  }
  
  .no-print, .no-print * {
    display: none !important;
  }
  .print-only {
    display: block !important;
  }
  
  .timeline-box {
    break-inside: avoid !important;
  }
  
  .timeline-date {
    color: white !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  .firstpagePdf {
    height: 1038px !important;
    padding-left: 30px !important;
  }
  .card {
    border: 1px solid #ddd !important;
    box-shadow: none !important;
  }
  
  .timeline-image img {
    max-height: 250px !important;
    width: 100% !important;
    height: 150% !important;
    max-width: 100% !important;
  }
  
  .scrollmenu {
    overflow: visible !important;
    white-space: normal !important;
  }
  
  .scrollmenu a {
    display: inline-block !important;
    margin-right: 10px !important;
  }
  
  .scrollmenu img {
    max-width: 80px !important;
    height: auto !important;
  }
  
  h1, h2, h3, h4, h5, h6 {
    page-break-after: avoid !important;
  }
  
  p, h2, h3 {
    orphans: 3 !important;
    widows: 3 !important;
  }
  
  .timeline-left .timeline-box {
    margin-left: 0 !important;
  }
  
  .timeline-item .timeline-box {
    margin-right: 0 !important;
  }
  
  .timeline::before {
    display: none !important;
  }
  
  .timeline-icon {
    display: none !important;
  }
  
  .time-showbtn {
    page-break-before: always !important;
    margin-top: 20px !important;
  }
  
  .time-showbtn .btn {
    border: none !important;
    color: white !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  
  .Tophead, #top, #topbtn {
    display: none !important;
  }
  
  .print-header {
    display: flex !important;
    justify-content: flex-start !important;
    align-items: center !important;
    margin-bottom: 20px !important;
  }
  
  .print-logo {
    max-width: 150px !important;
  }
  
  .print-title {
    font-size: 24px !important;
    font-weight: bold !important;
    text-align: center !important;
    flex-grow: 1 !important;
  }
  
  .print-date {
    font-size: 12px !important;
    text-align: left !important;
  }
  
  .print-footer {
    position: fixed !important;
    bottom: 0 !important;
    width: 100% !important;
    text-align: center !important;
    font-size: 10px !important;
    padding: 5px 0 !important;
    border-top: 1px solid #ddd !important;
  }
  
  .print-page-number:after {
    content: counter(page) !important;
  }
  
  .commentHTMLData img {
    max-width: 100% !important;
    height: auto !important;
  }
  .nameHeader {
    padding-top: 35% !important;
    margin-bottom: 20% !important;
  }

  .card-body {
    margin: 10px !important;
  }
  .PrintStart {
    justify-content: flex-start !important;
  }

  /* Ensure full content visibility */
  a.text-primary {
    display: none !important;
  }
  .expanded-content {
    display: block !important;
    max-height: none !important;
    overflow: visible !important;
  }

  /* Mobile-specific adjustments */
  @media screen and (max-width: 768px) {
    body {
      width: 210mm !important; /* A4 width */
      margin: 0 !important;
      padding: 0 !important;
      transform: scale(1) !important; /* Prevent mobile scaling */
    }

    .page-content {
      width: 210mm !important; /* Match A4 width */
      max-width: 210mm !important;
      box-sizing: border-box !important;
      padding: 0 !important;
      margin: 0 auto !important;
    }

    /* Override Bootstrap responsive classes */
    .container, .row, .col, .col-lg-12, .col-xl-10 {
      width: 100% !important;
      max-width: 100% !important;
      margin-left: 0 !important;
      margin-right: 0 !important;
      padding-left: 5mm !important;
      padding-right: 5mm !important;
      float: none !important;
    }

    /* Ensure images scale properly */
    img, .timeline-image img, .commentHTMLData img {
      width: 100% !important;
      max-width: 100% !important;
      height: auto !important;
    }

    /* Adjust first page height for mobile */
    .firstpagePdf {
      height: auto !important;
      padding-left: 10px !important;
    }

    /* Maintain timeline layout */
    .timeline-box {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
}
`;




const customStyles = {
    overlay: {
        marginTop: '70px'
    }
}

class TimelineData extends Component {
    constructor(props) {
        super(props);
        this.myRef = [] 
        this.state = {
            image_name:"",
            image_desc:"",
            itinerary:{},
            Places:"",
            selected_vehicle:"Chariot",
            isGallery: false,
            images : [],
            images_name :[],
            photoIndex:0,
            heading:"",
            desc:"",
            terms_condition: [],
            inclusitions:[],
            exclusitions:[],
            signature:null,
            bank_name: "",
            ifsc:"",
            account_no:"",
            account_name:"",
            upi:"",
            adults :0,
            teens :0,
            kids :0,
            backgroundColor:"#808080",
            activeTabJustify:"5",
            authenticated:false,
            editorState: EditorState.createEmpty(),
            rawMessage:'',
            time_plan:[],
            expandedItems: {},
            print: false,
            isPaymentExpanded: false,
            isIncludesExpanded: false,
            isTermsExpanded: false,
        }

        toastr.options = {
            positionClass: "toast-top-right",
            closeButton: "true",
            progressBar: "true",
            showEasing: "swing",
            hideEasing: "linear",
            showMethod: "fadeIn",
            hideMethod: "fadeOut",
            showDuration: 300,
            hideDuration: 1000,
            timeOut: 5000,
            extendedTimeOut: 1000
        }
        
        this.tog_payment = this.tog_payment.bind(this)
        this.tog_center = this.tog_center.bind(this);
        this.tog_terms = this.tog_terms.bind(this);
        this.tog_inc_exc = this.tog_inc_exc.bind(this);
        this.tog_color_picker = this.tog_color_picker.bind(this)
        this.onDragRgb = this.onDragRgb.bind(this)
        this.SaveBackgroundColor = this.SaveBackgroundColor.bind(this)
        this.onWheel = this.onWheel.bind(this)
        this.tog_share = this.tog_share.bind(this)
        this.toggleCustomJustified = this.toggleCustomJustified.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.HandleValidateUserSubmit = this.HandleValidateUserSubmit.bind(this)
        this.onEditorStateChange = this.onEditorStateChange.bind(this)
        this.toPrint = this.toPrint.bind(this)
    }

    onWheel(e, id){
        e.preventDefault();
        const container = document.getElementById(id);
        const containerScrollPosition = document.getElementById(id).scrollLeft;
    
        container.scrollTo({
          top: 0,
          left: containerScrollPosition + e.deltaY,
          behaviour: "smooth"
        });
    }

    scroll_to_component(index){
        this.myRef[parseInt(index)].scrollIntoView()
    }

    // Enhanced print function with better styling and preparation
    toPrint = () => {
        // Store current expanded states
        const expandedState = {
          isPaymentExpanded: this.state.isPaymentExpanded,
          isIncludesExpanded: this.state.isIncludesExpanded,
          isTermsExpanded: this.state.isTermsExpanded,
        };
        
        // Expand all sections for printing
        this.setState(
          {
            isPaymentExpanded: true,
            isIncludesExpanded: true,
            isTermsExpanded: true,
          },
          () => {
            // Add print styles
            const styleElement = document.createElement('style');
            styleElement.id = 'print-styles';
            
            // Create print styles with better mobile support
            const enhancedPrintStyles = `
              @media print {
                @page {
                  size: A4;
                  margin: 0.5cm;
                }
                
                /* Base print styles */
                body {
                  -webkit-print-color-adjust: exact !important;
                  print-color-adjust: exact !important;
                  color-adjust: exact !important;
                  font-size: 16px !important;
                  width: auto !important;
                  height: auto !important;
                  margin: 0 !important;
                }
                
                /* Hide Read More/Less links */
                a.text-primary {
                  display: none !important;
                }
                
                /* Ensure expanded content is fully visible */
                .expanded-content {
                  display: block !important;
                  max-height: none !important;
                  overflow: visible !important;
                }
                
                /* Remove truncation */
                [style*="max-height"],
                [style*="WebkitLineClamp"],
                [style*="-webkit-line-clamp"] {
                  max-height: none !important;
                  -webkit-line-clamp: unset !important;
                  overflow: visible !important;
                  display: block !important;
                }
                
                /* Ensure content fits within page */
                .container {
                  width: 100% !important;
                  max-width: 100% !important;
                  flex: 0 0 100% !important;
                  padding: 0 5mm !important;
                  margin: 0 !important;
                }
                
                /* Better image handling */
                img {
                  max-width: 100% !important;
                  height: auto !important;
                }
                
                ${printStyles || ''}
              }
              
              /* Special handling for mobile devices */
              @media print and (max-width: 600px) {
                body {
                  width: 100% !important;
                  margin: 0 !important;
                  padding: 0 !important;
                }
                .firstpagePdf {
                  height: 900px !important;
                }
                .page-content {
                  width: 100% !important;
                  max-width: 100% !important;
                  padding: 0 !important;
                  margin: 0 !important;
                }
                
                /* Adjust card margins for mobile */
                .card {
                  margin: 5px 0 !important;
                  width: 100% !important;
                }
                
                /* Simpler timeline for mobile print */
                .timeline-box {
                  margin: 10px 0 !important;
                  width: 100% !important;
                }
                
                /* Reduce padding for mobile */
                .card-body {
                  padding: 5px !important;
                }
              }
            `;
            
            styleElement.textContent = enhancedPrintStyles;
            document.head.appendChild(styleElement);
            
            // Set viewport for better mobile printing
            let meta = document.querySelector('meta[name="viewport"]');
            const originalViewport = meta ? meta.content : null;
            
            if (!meta) {
              meta = document.createElement('meta');
              meta.name = 'viewport';
              document.head.appendChild(meta);
            }
            
            // Use print-optimized viewport
            meta.content = 'width=device-width, initial-scale=1.0, maximum-scale=1.0';
            
            // Trigger print
            window.print();
            
            // Cleanup and restore original state
            setTimeout(() => {
              // Restore original viewport if it existed
              if (originalViewport) {
                meta.content = originalViewport;
              } else {
                document.head.removeChild(meta);
              }
              
              // Remove print styles
              document.head.removeChild(styleElement);
              
              // Restore UI state
              this.setState(expandedState);
            }, 500); // Short delay to ensure print dialog has fully initialized
          }
        );
      };
    onEditorStateChange = (editorState) => {
        this.setState({
          editorState,
          rawMessage: draftToHtml(convertToRaw(editorState.getCurrentContent()))
        });
    };
    
    scrollFunction() {
        let mybutton = document.getElementById('top-btn')
        let scrollToTop = document.getElementById('top')
        if(mybutton || scrollToTop){
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                if (scrollToTop) scrollToTop.style.display = "block";
            } else {
                if (scrollToTop) scrollToTop.style.display = "none";
            }
        }
    }

    componentDidCatch(){
        localStorage.getItem("authUser") ? this.props.history.push('/itineraries') : this.props.history.push('/404')
    }

    removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    tog_center() {
        this.setState(prevState => ({
          modal_center: !prevState.modal_center
        }));
        this.removeBodyCss();
    }

    tog_terms() {
        this.setState(prevState => ({
          modal_terms: !prevState.modal_terms
        }));
        this.removeBodyCss();
    }
      
    tog_inc_exc() {
        this.setState(prevState => ({
            modal_inc_exc: !prevState.modal_inc_exc
        }));
        this.removeBodyCss();
    }

    tog_payment() {
        this.setState(prevState => ({
            modal_payment: !prevState.modal_payment
        }));
        this.removeBodyCss();
    }

    tog_color_picker() {
        this.setState(prevState => ({
            modal_color_picker: !prevState.modal_color_picker
        }));
        this.removeBodyCss();
    }

    tog_share() {
        this.setState(prevState => ({
            modal_share: !prevState.modal_share
        }));
        this.removeBodyCss();
    }

    toggleCustomJustified(tab) {
        if (this.state.activeTabJustify !== tab) {
            this.setState({
                activeTabJustify: tab
            });
        }
    }

    onDragRgb(c1) {
        this.setState({ backgroundColor: c1 });
    }
    
    componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollFunction, { passive: false });
        this._isMounted = false;
    }

    async componentDidMount() {
        window.addEventListener('scroll', this.scrollFunction, { passive: false });

        await this.loaditineraryPax()
        await this.loadData()
        await this.loadDailyPlanData()
        await this.loadFooterData()
        await this.loadBankDetaildata()
    }
    
    async loadData(){
        let id = this.props.id
        
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        await fetch(`${BaseUrl}/api/itineraries/itineraries/${id}/`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    console.log(data, "data")
                    let date_diff = getDifferenceInDays(new Date(data.end_date), new Date(data.start_date))
                    let Places = `${date_diff+1} days in `
                    for(let i=0; i < (data.destinations).length ; i++){
                        if (i===0){
                            Places = Places+data.destinations[i].name
                        } else if (i=== (data.destinations).length-1){
                            Places = Places+" & "+data.destinations[i].name
                        } else {
                            Places = Places+", "+data.destinations[i].name
                        }
                    }
                    document.title = data.title+" | Planmans";
                    if (localStorage.getItem(`${id}`) === 'true'){
                        this.setState({authenticated:true})
                    }
                    this.setState({ itinerary: data, Places, backgroundColor: data.background_color })
                },
                (error) => {
                    console.log(error, 'error------') 
                    localStorage.getItem("authUser") ? this.props.history.push('/itineraries') : this.props.history.push('/404')
                }
            ) 
    }

    async loadBankDetaildata(){
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        await fetch(`${BaseUrl}/api/cms/payment-detail/1/`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    this.setState({ 
                        account_name: data.account_name, 
                        bank_name: data.bank_name, 
                        ifsc: data.ifsc, 
                        account_no: data.account_no, 
                        upi: data.upi 
                    })
                },
                (error) => {
                    console.log(error, 'error------') 
                    localStorage.getItem("authUser") ? this.props.history.push('/itineraries') : this.props.history.push('/404')
                }
            )  
    }

    async loadDailyPlanData(){
        let id = this.props.id
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        await fetch(`${BaseUrl}/api/itineraries/itinerary-daily-plan/?itinerary__id=${id}&size=50`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    if(data.count === 0){
                        if (localStorage.getItem("authUser")){
                            toastr.info("Data is not Available", "")
                            this.props.history.push('/itineraries')
                        } else {
                            this.props.history.push('/404')
                        }
                    } else {
                        this.setState({daily_plan: data.results})
                    }
                    console.log(data,"dailydata")
                },    
                (error) => {
                    console.log(error, 'error--------------')
                    localStorage.getItem("authUser") ? this.props.history.push('/itineraries') : this.props.history.push('/404')
                }
            )  
    }

    async loaditineraryPax() {
        let id = this.props.id;
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        
        try {
            const response = await fetch(
                `${BaseUrl}/api/itineraries/itineraries/${id}/`, 
                requestOptions
            );
            
            if (!response.ok) {
                throw new Error('HTTP error ' + response.status);
            }
    
            const data = await response.json();
            
            // Calculate totals from direct API response values
            const adults = data.adults_male + data.adults_female;
            const teens = data.teens_male + data.teens_female;
            const kids = data.kids_male + data.kids_female;
    
            this.setState({ adults, teens, kids });
            
        } catch (error) {
            console.error('Fetch error:', error);
            if (localStorage.getItem("authUser")) {
                this.props.history.push('/itineraries');
            } else {
                this.props.history.push('/404');
            }
        }
    }

    async loadFooterData(){
        let id = this.props.id
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
        };
        await fetch(`${BaseUrl}/api/itineraries/itinerary-footer-detail/${id}/`, requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    let terms_condition = []
                    if(data.terms_condition){
                        terms_condition = data.terms_condition
                    }
                    this.setState({ 
                        terms_condition: terms_condition, 
                        signature: data.signature,
                        inclusitions: data.inclusitions, 
                        exclusitions: data.exclusitions 
                    })
                },   
                (error) => {
                    console.log(error, 'error--------------') 
                    localStorage.getItem("authUser") ? this.props.history.push('/itineraries') : this.props.history.push('/404')
                }
            )  
    }
  
    getNextDays(date, count) {
        let result = new Date(date);
        result.setDate(result.getDate() + count);
        return Moment(result).format("DD-MM-YYYY");
    }

    onImageClick(images, name="image", desc=""){
        let image = []
        let images_name = []
        for (let i=0; i<images.length; i++){
            image.push(BaseUrl+images[i].image)
            images_name.push(images[i].name)
        }
        this.setState({ 
            isGallery: true, 
            photoIndex: 0, 
            images: image, 
            image_name: name, 
            image_desc: desc, 
            images_name 
        })
    }

    SaveBackgroundColor(){
        const { backgroundColor } = this.state
        const obj = JSON.parse(localStorage.getItem("authUser"));
        if (validateToken(obj.access)){
            this.setState({ loading: true })
            let data = {"background_color": backgroundColor}
            const requestOptions = {
                method: 'PUT',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${obj.access}`  
                },
                body: JSON.stringify(data)
            };
            fetch(`${BaseUrl}/api/itineraries/itineraries/${this.props.id}/`, requestOptions)
                .then(res => {
                    if(res.status >= 400){
                        res.json()
                        .then(
                            (data) => {  
                                console.log(data, "---data")
                                toastr.error("Something Went Wrong", "") 
                                this.setState({ loading: false })
                            }    
                        )
                    } else {
                        this.tog_color_picker()
                        this.setState({ loading: false })
                    }    
                })
        } else {
            this.props.history.push('/logout')
        } 
    }

    handleSubmit(e, values){
        const obj = JSON.parse(localStorage.getItem("authUser"));
        if (validateToken(obj.access)){
            const { rawMessage } = this.state
            let message = encodeURIComponent(rawMessage)
            this.setState({ loading: true })
            let data = {
                "email": values.email,
                "data": message,
                "subject": values.subject,
            }
            const requestOptions = {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${obj.access}`  
                },
                body: JSON.stringify(data)
            };
            fetch(`${BaseUrl}/api/itineraries/send-email/`, requestOptions)
            .then(res => {
                if(res.status >= 400){
                    this.setState({ loading: false })
                } else {
                    this.tog_share()
                    toastr.success("Email Successfully Sent")
                    this.setState({ loading: false })
                }    
            })
        } else {
            this.props.history.push('/logout')
        }
    }

    // To validate User is Genuine 
    HandleValidateUserSubmit(e, values){
        const { itinerary } = this.state
        let phone = itinerary.phone
        if(phone[0] === "+"){
            phone = phone.split("-")[1]
        }
        if(phone === values.password){
            localStorage.setItem(`${itinerary.id}`, true);   
            this.setState({authenticated: true})
        } else {
            toastr.error("Invalid Password")
        }
    }

    // Function to format currency with commas
    formatCurrency(amount) {
        return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    render() {
        const { 
            itinerary, image_name, image_desc, daily_plan, images, photoIndex, inclusitions, exclusitions, 
            terms_condition, adults, teens, kids, images_name, signature, print
        } = this.state;
        
        let startDate = itinerary.start_date ? Moment(itinerary.start_date).format("MMM Do YYYY") : Moment().format("MMM Do YYYY");
        let endDate = itinerary.end_date ? Moment(itinerary.end_date).format("MMM Do YYYY") : Moment().format("MMM Do YYYY");
        
        let breadcrumbItems = [
            { title: "Itineraries", link: "/itineraries" },
            { title: itinerary.name, link: `/itinerary-detail/${itinerary.id}` },
            { title: "View Itinerary", link: "#" },
        ];
        
        const adultsNum = Number(adults) || 0;
        const teensNum = Number(teens) || 0;
        const kidsNum = Number(kids) || 0;
        const totalPax = adultsNum + teensNum;
        const margin = Number(itinerary.pkg_const_margin) || 0;
        const costPerPax = totalPax > 0 ? (margin / totalPax).toFixed(2) : "N/A";
        const cleanHTML = (html) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
        
            // Remove empty <p> tags
            doc.querySelectorAll('p').forEach(p => {
                if (!p.textContent.trim()) {
                    p.remove();
                }
            });
        
            // Remove <br> tags
            doc.querySelectorAll('br').forEach(br => br.remove());
        
            return doc.body.innerHTML;
        };
        
        
        const currentDate = Moment().format("MMMM Do, YYYY");
        
        return (
            <React.Fragment>
                {!isEmpty(itinerary && daily_plan) ? (
                    <div className={localStorage.getItem("authUser") ? "page-content" : print ? "page-content mt-4" : "container mt-4"}>
                        {/* Print-only header */}
                        {print && (
                            <div className="print-only print-header">
                                <div className="print-logo">
                                    {signature && signature.logo ? (
                                        <img src={signature.logo || "/placeholder.svg"} alt="Company Logo" style={{ maxWidth: '150px' }} />
                                    ) : (
                                        <h3>Planmans</h3>
                                    )}
                                </div>
                                <div className="print-title">
                                    {itinerary.title}
                                </div>
                                <div className="print-date">
                                    Printed on: {currentDate}
                                </div>
                            </div>
                        )}
                        
                        {this.state.isGallery ? (
                            <Lightbox
                                reactModalStyle={localStorage.getItem("authUser") ? customStyles : ""}
                                mainSrc={images[photoIndex]}
                                nextSrc={photoIndex === images.length - 1 ? "" : images[(photoIndex + 1) % images.length]}
                                nextSrcThumbnail={images[photoIndex]}
                                prevSrc={
                                    photoIndex === 0 ? "" : images[(photoIndex + images.length - 1) % images.length]
                                }
                                enableZoom={false}
                                onCloseRequest={() => this.setState({ isGallery: false })}
                                onMovePrevRequest={() =>
                                    this.setState({
                                        photoIndex: (photoIndex + images.length - 1) % images.length
                                    })
                                }
                                onMoveNextRequest={() =>
                                    this.setState({
                                        photoIndex: (photoIndex + 1) % images.length
                                    })
                                }
                                imageTitle={`Image: ${images_name[photoIndex]}`}
                                imageCaption={`${image_name}: ${image_desc}`}
                            />
                        ) : null}

                        {!print ? (
                            this.state.authenticated || this.props.user ? (
                                <Container fluid>
                                    {localStorage.getItem("authUser") ?
                                        <Breadcrumbs title={""} breadcrumbItems={breadcrumbItems} />
                                    :
                                        <p>{itinerary.title}</p>
                                    }

                                    <div id="timeLine">
                                        <Row>
                                            <Col lg={12}>
                                                <Card style={{backgroundColor: this.state.backgroundColor}}>
                                                    <a id="top" href="#" className="no-print">Back to Top ↑</a>
                                                    <CardBody className='firstpagePdf'>
                                                        {this.props.user ?
                                                            <Link to="#" onClick={this.tog_color_picker} className="me-3 text-dark float-end no-print">
                                                                <i className="fas fa-paint-brush font-size-18"></i>
                                                            </Link>
                                                        : null}
                                                        <Row>
                                                            <Col lg={6}>
                                                                <div className="text-center align-items-center justify-content-center nameHeader">
                                                                    <h1 className="" style={{color: "white",textTransform: 'uppercase'}}>
                                                                        <i className="fas fa-map-signs"></i> {itinerary.name}
                                                                    </h1>
                                                                    <h6 className="mb-4" style={{color: "white"}}>
                                                                        <i className="fas fa-calendar-alt font-size-20"></i> {startDate} - {endDate}
                                                                    </h6>
                                                                    <h6 className="mb-4" style={{color: "white"}}>
                                                                        <i className="fas fa-user font-size-20"></i> {itinerary.customer_name}
                                                                    </h6>
                                                                </div>
                                                            </Col>
                                                            <Col lg={6}>
                                                                <p style={{fontSize: "1rem", color: "white"}}>
                                                                    <i className="fas fa-clipboard-list font-size-15"></i> 
                                                                    <b className='bold'>{" Package Type: "}</b>{itinerary.packege}
                                                                </p>
                                                                <p style={{fontSize: "1rem", color: "white"}}>
                                                                    <i className="fas fa-route font-size-15"></i> 
                                                                    <b className='bold'>{" Destinations: "}</b>
                                                                    {itinerary.destinations.map((destini, index) => {
                                                                        return ((itinerary.destinations).length-1 === index ? 
                                                                            destini.name : destini.name+", ")
                                                                    })}
                                                                </p>
                                                                {/* <p style={{color: "white", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}}
                                                                    id="placesContainer">
                                                                    <i className="fas fa-mountain font-size-15"></i> 
                                                                    <b className='bold'>{" Places: "}</b>
                                                                    {itinerary.places.slice(0, 3).map((destini, index) => (
                                                                        (itinerary.places.slice(0, 3).length - 1 === index) ? 
                                                                            destini.name : destini.name + ", "
                                                                    ))}
                                                                    {itinerary.places.length > 3 && (
                                                                        <>
                                                                            <span id="fullPlacesList" className="d-none">
                                                                                {itinerary.places.slice(3).map((destini, index) => (
                                                                                    (itinerary.places.length - 1 === index + 3) ? 
                                                                                        destini.name : destini.name + ", "
                                                                                ))}
                                                                            </span>
                                                                            <span 
                                                                                style={{ cursor: 'pointer' }}
                                                                                onClick={() => {
                                                                                    const fullList = document.getElementById('fullPlacesList');
                                                                                    const viewMoreLess = document.getElementById('viewMoreLess');
                                                                                    const placesContainer = document.getElementById('placesContainer');

                                                                                    fullList?.classList.toggle('d-none');

                                                                                    if (viewMoreLess) {
                                                                                        if (fullList?.classList.contains('d-none')) {
                                                                                            viewMoreLess.textContent = ' ...';
                                                                                            placesContainer.style.whiteSpace = "nowrap";  // Stay in one line
                                                                                        } else {
                                                                                            viewMoreLess.textContent = ' view less';
                                                                                            placesContainer.style.whiteSpace = "normal"; // Expand to multiple lines
                                                                                        }
                                                                                    }
                                                                                }}
                                                                            >
                                                                                <span id="viewMoreLess" style={{ fontSize: "large", color: "white" }}> ...</span>
                                                                            </span>
                                                                        </>
                                                                    )}
                                                                </p> */}
                                                                <p style={{fontSize: "1rem", color: "white"}}>
                                                                    <i className="fas fa-users font-size-15"></i>
                                                                    <b className='bold'> {"No of PAX: "}</b>
                                                                    {adultsNum} Adults{teensNum !== 0 ? `, ${teensNum} Teens` : ""}
                                                                    {kidsNum !== 0 ? kidsNum > 1 ? `, ${kidsNum} Kids` : `, ${kidsNum} Kid` : ""}
                                                                </p>
                                                                <p style={{fontSize: "1rem", color: "white"}}>
                                                                    <i className="fas fa-pizza-slice font-size-15"></i> 
                                                                    <b className='bold'> {"Meal Plan: "}</b>{"MAP"}
                                                                </p>
                                                                <p style={{fontSize: "1rem", color: "white"}}>
                                                                    <i className="fas fa-money-check-alt font-size-15"></i> 
                                                                    <b className='bold'> {"Total Cost: "}</b>₹ {this.formatCurrency(margin.toFixed(2))}
                                                                </p>
                                                                <p style={{fontSize: "1rem", color: "white"}}>
                                                                    <i className="fas fa-money-bill-alt font-size-15"></i> 
                                                                    <b class="bold"> {"Per PAX Cost: "}</b>₹ {this.formatCurrency(costPerPax)}
                                                                </p>
                                                            </Col>
                                                        </Row>
                                                    </CardBody>
                                                </Card>
                                            </Col>
                                        </Row>
                                        
                                        <Row className="justify-content-center Tophead no-print">
    <Col sm={10} className="text-center">
        <div className="horizontal-scroll-container">
            <div className="horizontal-scroll-wrapper">
                <Link to="#" onClick={() => this.scroll_to_component(0)} className="btn btn-link btn-rounded w-sm me-2">
                    <i className="fas fa-rupee-sign font-size-15"></i> Payment
                </Link>
                <Link to="#" onClick={() => this.scroll_to_component(1)} className="btn btn-link btn-rounded w-sm me-2">
                    <i className="fas fa-phone-volume font-size-15"></i> Contact
                </Link>
                <Link to="#" onClick={() => this.scroll_to_component(2)} className="btn btn-link btn-rounded w-sm me-2">
                    <i className="fas fa-clipboard-list font-size-15"></i> Incl. & Excl.
                </Link>
                <Link to="#" onClick={() => this.scroll_to_component(3)} className="btn btn-link btn-rounded w-sm me-2">
                    <i className="far fa-list-alt font-size-15"></i> T&C
                </Link>
                <Link to="#" onClick={() => this.toPrint()} className="btn btn-link btn-rounded w-sm me-2">
                    <i className="fas fa-print font-size-15"></i> Print/Download
                </Link>
                {localStorage.getItem("authUser") ? (
                    <Link to="#" onClick={() => this.tog_share()} className="btn btn-link btn-rounded w-sm me-2">
                        <i className="fas fa-share-alt font-size-15"></i> Share
                    </Link>
                ) : null}
            </div>
        </div>
    </Col>
</Row>
                                        <div className='mt-4 '></div>

                                        <Row className="justify-content-center mt-2">
                                            <Col xl={10}>
                                                <div className="timeline" dir="ltr">
                                                    <div className="timeline-item timeline-left pagebreakavoid">
                                                        <div className="timeline-block">
                                                            <div className="time-show-btn mt-0 mb-0 ">
                                                                <Link to="#" className="btn btn-primary btn-rounded w-lg Tourstartcolor">
                                                                    Tour Starts: {itinerary.pick_up_location ? itinerary.pick_up_location.name : ""}
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {daily_plan.map((data, index) => {
                                                        return (
                                                            (index+2) % 2 === 0 ? (
                                                                <div className="timeline-item pagebreak " key={`day-${data.day}`}>
                                                                    <div className="timeline-block alignrightpage">
                                                                        <Card className="timeline-box timeline-box-mobile">
                                                                            <CardBody>
                                                                                <span className="timeline-icon"></span>
                                                                                <div className="timeline-date timeline-date-new">
                                                                                    <i className="mdi mdi-circle-medium circle-dot"></i>
                                                                                    Day {data.day} ({this.getNextDays(itinerary.start_date, data.day-1)})
                                                                                </div>
                                                                                <div className='mt-3 timeline-image'>
                                                                                    <img 
                                                                                        src={`${BaseUrl}${data.current_location.image[0].image}`} 
                                                                                        style={{width: "100%", height: "100%" , objectFit: "cover"}}
                                                                                        alt={data.current_location.name}
                                                                                        className='rounded-2'
                                                                                    />
                                                                                </div>
                                                                                <h5 className="mt-3 underline-smallforheading">
                                                                                    {data.heading ? 
                                                                                        data.heading : 
                                                                                        (data.to_travel ?
                                                                                            `${data.current_location.name} to ${data.to_travel.name} (${calculateDistance(data.current_location.coordinates, data.to_travel.coordinates)} KM)`
                                                                                            :
                                                                                            `${data.current_location.name} Sight Seeing`)
                                                                                    }
                                                                                </h5>
                                                                                <div className="text-muted">
    {data.comment === "" ? (
        <>
            {this.state[`expanded_${data.id}`] ? (
                <p>
                    {data.to_travel 
                        ? data.to_travel.description 
                        : data.current_location.description}
                    <Link
                        to="#"
                        onClick={() => this.setState(prevState => ({
                            [`expanded_${data.id}`]: !prevState[`expanded_${data.id}`]
                        }))}
                        className="d-block mt-0 text-primary"
                    >
                        Show Less
                    </Link>
                </p>
            ) : (
                <div className="position-relative">
                    <p className="mb-0" style={{ 
                        display: "-webkit-box", 
                        WebkitLineClamp: "2", 
                        WebkitBoxOrient: "vertical", 
                        overflow: "hidden",
                        paddingRight: "70px" // Make space for the "Read More" link
                    }}>
                        {data.to_travel 
                            ? data.to_travel.description 
                            : data.current_location.description}
                    </p>
                    <Link
                        to="#"
                        onClick={() => this.setState({ [`expanded_${data.id}`]: true })}
                        className="text-primary position-absolute"
                        style={{ 
                            bottom: "0", 
                            right: "0"
                        }}
                    >
                        Read More
                    </Link>
                </div>
            )}
        </>
    ) : (
        <>
            {this.state[`expanded_${data.id}`] ? (
                <p>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: cleanHTML(data.comment),
                        }}
                    />
                    <Link
                        to="#"
                        onClick={() =>
                            this.setState((prevState) => ({
                                [`expanded_${data.id}`]: !prevState[`expanded_${data.id}`],
                            }))
                        }
                        className="text-primary ms-1"
                    >
                        Show Less
                    </Link>
                </p>
            ) : (
                <div className="position-relative">
                    <p className="mb-0" style={{ 
                        display: "-webkit-box", 
                        WebkitLineClamp: "2", 
                        WebkitBoxOrient: "vertical", 
                        overflow: "hidden",
                        paddingRight: "70px" // Make space for the "Read More" link
                    }}>
                        <span
                            className="commentHTMLData"
                            dangerouslySetInnerHTML={{
                                __html: cleanHTML(data.comment)
                            }}
                        />
                    </p>
                    {data.comment.length > 100 && (
                        <Link
                            to="#"
                            onClick={() => this.setState({ [`expanded_${data.id}`]: true })}
                            className="text-primary position-absolute"
                            style={{ 
                                bottom: "0", 
                                right: "0"
                            }}
                        >
                            Read More
                        </Link>
                    )}
                </div>
            )}
        </>
    )}
</div>




                                                                                {/* Hotels and Stays Section */}
                                                                                {data.hotels.length !== 0 ? (
    data.hotels.length > 1 ? (
        <Row>
            <Col>
                <h6 className="card-title mt-2 underline-small"style={{textAlign: 'left'}}>{"Hotels and Stays:"}</h6>
                <div
                    className="PrintStart d-flex gap-2 justify-content-start"
                    style={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                        overflowX: 'hidden',
                        maxWidth: '100%',
                        paddingBottom: '10px',

                    }}
                >
                    {data.hotels.map((hotel) => {
                        return (
                            <Link
                                to="#"
                                className="me-2 text-dark text-center"
                                style={{
                                    flex: '0 0 33.33%',
                                    width: '100px',
                                    maxWidth: '31.5%',
                                }}
                                key={hotel.name}
                            >
                                <div className="d-flex flex-column align-items-center ">
                                    <img
                                        src={`${BaseUrl}${hotel.images[0].image}`}
                                        onClick={() =>
                                            this.onImageClick(hotel.images, hotel.name, hotel.description)
                                        }
                                        alt={hotel.name}
                                        className="rounded-2 hotel-image"
                                        style={{
                                            width: '100%',
                                            height: '90px',
                                            // maxHeight: '62px',
                                            objectFit: 'cover',
                                        }}
                                    />
                                    <p
                                        className="m-0 mt-1"
                                        style={{
                                            width: '100%',
                                            lineHeight: '1.2',
                                            textAlign: 'left',
                                        }}
                                    >
                                        {hotel.name}
                                    </p>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </Col>
        </Row>
    ) : (
        <Row>
            <Col>
                <h6 className="card-title mt-2 underline-small" style={{textAlign: 'left'}}>{"Hotels and Stays:"}</h6>
                <div
                    className="PrintStart d-flex gap-2 justify-content-start flex-column"
                    style={{
                        maxWidth: '100%',
                        paddingBottom: '10px',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                            overflowX: 'hidden',
                            justifyContent: 'left',
                            marginTop:'7px'
                        }}
                    >
                        {data.hotels[0].images.slice(0, 3).map((image, index) => {
                            return (
                                <Link
                                    to="#"
                                    className="me-2 text-dark"
                                    style={{
                                        flex: '0 0 33.33%',
                                        width: '100px',
                                        maxWidth: '31.5%',
                                    }}
                                    key={`${data.hotels[0].name}-img-${index}`}
                                >
                                    <div className="d-flex flex-column align-items-center">
                                        <img
                                            src={`${BaseUrl}${image.image}`}
                                            onClick={() =>
                                                this.onImageClick(data.hotels[0].images, data.hotels[0].name, data.hotels[0].description)
                                            }
                                            alt={`${data.hotels[0].name}`}
                                            className="rounded-2 hotel-image"
                                            style={{
                                                width: '100%',
                                                height: '90px',
                                                // maxHeight: '62px',
                                                objectFit: 'cover',
                                            }}
                                        />
                                    </div>
                                </Link>
                            );
                        })}
                    </div>
                    <p
                        className="m-0 mt-1 single-hotel-name"
                        style={{
                            width: '100%',
                            lineHeight: '1.2',
                            textAlign: 'left',
                            wordWrap: 'break-word',
                            whiteSpace: 'normal',
                        }}
                    >
                        {data.hotels[0].name}
                    </p>
                </div>
            </Col>
        </Row>
    )
) : null}



                                                                                {/* Transportation Section */}
                                                                                {(data.vehicle || data.multiple_vehicle?.length > 0) && (
    <Row>
        <h6 className="card-title mt-2 underline-smallfortransport">{`Transportation:`}</h6>
        {data.multiple_vehicle?.length > 1 ? (
            // Case: Multiple vehicles (more than one)
            <div
                className="PrintStart d-flex gap-2 justify-content-start"
                style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    overflowX: 'hidden',
                    width: '100%',
                    paddingBottom: '10px',
                }}
            >
                {data.multiple_vehicle.map((vehicle, index) => (
                    <Link
                        to="#"
                        className="me-2 text-dark text-center"
                        style={{
                            flex: '0 0 33.33%',
                            width: '100px',
                            maxWidth: '31.5%',
                        }}
                        key={`${vehicle.name || 'vehicle'}-${index}`}
                    >
                        <div className="d-flex flex-column align-items-center vehicle-imageAlign">
                            <img
                                src={`${BaseUrl}${vehicle.images?.[0]?.image}`}
                                onClick={() =>
                                    this.onImageClick(
                                        vehicle.images,
                                        vehicle.name,
                                        vehicle.description || ''
                                    )
                                }
                                alt={vehicle.name || 'Vehicle'}
                                className="rounded-2 vehicle-image"
                                style={{
                                    width: '100%',
                                    height: '90px',
                                    objectFit: 'cover',
                                }}
                            />
                            <p
                                className="m-0 mt-1 vehicle-name single-vehicle-name"
                                style={{
                                    width: '100%',
                                    lineHeight: '1.2',
                                    textAlign: 'left',
                                    wordWrap: 'break-word',
                                    whiteSpace: 'normal',
                                }}
                            >
                                {vehicle.name || 'Vehicle'}
                            </p>
                        </div>
                    </Link>
                ))}
            </div>
        ) : (
            // Case: Single vehicle
            <div
                className="PrintStart d-flex gap-2 justify-content-start flex-column"
                style={{
                    maxWidth: '100%',
                    paddingBottom: '10px',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                        overflowX: 'hidden',
                        justifyContent: 'left',
                        marginTop: '7px',
                    }}
                >
                    {(data.multiple_vehicle?.length === 1 ? data.multiple_vehicle[0].images : data.vehicle?.images)
                        ?.slice(0, 3)
                        .map((image, imgIndex) => (
                            <Link
                                to="#"
                                className="me-2 text-dark"
                                style={{
                                    flex: '0 0 33.33%',
                                    width: '100px',
                                    maxWidth: '31.5%',
                                }}
                                key={`${
                                    (data.multiple_vehicle?.length === 1
                                        ? data.multiple_vehicle[0].name
                                        : data.vehicle?.name) || 'vehicle'
                                }-img-${imgIndex}`}
                            >
                                <div className="d-flex flex-column align-items-center vehicle-imageAlign">
                                    <img
                                        src={`${BaseUrl}${image.image}`}
                                        onClick={() =>
                                            this.onImageClick(
                                                data.multiple_vehicle?.length === 1
                                                    ? data.multiple_vehicle[0].images
                                                    : data.vehicle.images,
                                                data.multiple_vehicle?.length === 1
                                                    ? data.multiple_vehicle[0].name
                                                    : data.vehicle.name,
                                                (data.multiple_vehicle?.length === 1
                                                    ? data.multiple_vehicle[0].description
                                                    : data.vehicle.description) || ''
                                            )
                                        }
                                        alt={
                                            (data.multiple_vehicle?.length === 1
                                                ? data.multiple_vehicle[0].name
                                                : data.vehicle?.name) || 'Vehicle'
                                        }
                                        className="rounded-2 vehicle-image"
                                        style={{
                                            width: '100%',
                                            height: '90px',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>
                            </Link>
                        ))}
                </div>
                <p
                    className="m-0 mt-1 vehicle-name single-vehicle-name"
                    style={{
                        width: '100%',
                        lineHeight: '1.2',
                        textAlign: 'left',
                        wordWrap: 'break-word',
                        whiteSpace: 'normal',
                    }}
                >
                    {(data.multiple_vehicle?.length === 1
                        ? data.multiple_vehicle[0].name
                        : data.vehicle?.name) || 'Vehicle'}
                </p>
            </div>
        )}
    </Row>
)}
                                                                                {/* Places to Visit Section */}
                                                                                <Row>
                                                                                    <Col>
                                                                                        <h6 className="card-title mt-2 underline-small">{"Places to Visit: "}</h6>
                                                                                        <div className="d-flex flex-column align-items-start ps-0 position-relative" style={{marginTop: '10px'}}>
                                                                                            
                                                                                            <div className="textPara-fix">
                                                                                                {(() => {
                                                                                                    const placesToShow = [];
                                                                                                    
                                                                                                    placesToShow.push(
                                                                                                        <a
                                                                                                            key={data.current_location.id}
                                                                                                            href={`/location/${data.current_location.id}`}
                                                                                                            target="_blank"
                                                                                                            rel="noopener noreferrer"
                                                                                                            className="text-dark text-decoration-none lh-1"
                                                                                                        >
                                                                                                            <p style={{color: 'blue'}}>{data.current_location.name.substring(0, 12)}</p>
                                                                                                        </a>
                                                                                                    );

                                                                                                    if (data.to_travel) {
                                                                                                        placesToShow.unshift(
                                                                                                            <a
                                                                                                                key={data.to_travel.id}
                                                                                                                href={`/location/${data.to_travel.id}`}
                                                                                                                target="_blank"
                                                                                                                rel="noopener noreferrer"
                                                                                                                className="text-dark text-decoration-none lh-1"
                                                                                                            >
                                                                                                                <p style={{color: 'blue'}}>{data.to_travel.name}</p>
                                                                                                            </a>
                                                                                                        );
                                                                                                    }

                                                                                                    data.visiting_places.forEach(place => {
                                                                                                        if (place.id !== data.to_travel?.id && place.id !== data.current_location.id) {
                                                                                                            placesToShow.unshift(
                                                                                                                <a
                                                                                                                    key={place.id}
                                                                                                                    href={`/location/${place.id}`}
                                                                                                                    target="_blank"
                                                                                                                    rel="noopener noreferrer"
                                                                                                                    className="text-dark text-decoration-none lh-1"
                                                                                                                >
                                                                                                                    <p style={{color: 'blue'}}>{place.name}</p>
                                                                                                                </a>
                                                                                                            );
                                                                                                        }
                                                                                                    });

                                                                                                    return placesToShow.map((place, index) => (
                                                                                                        <React.Fragment key={`fragment-${index}`}>
                                                                                                            {index > 0 && <span className="me-1">, </span>}
                                                                                                            {place}
                                                                                                        </React.Fragment>
                                                                                                    ));
                                                                                                    
                                                                                                })()}
                                                                                            </div>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>

                                                                                {/* Activities Section */}
                                                                                {data.activity.length !== 0 ? (
    <Row>
        <h4 className="card-title mt-2 underline-smallfortransport padding-top">{`Activities Today: `}</h4>
        <div className="d-flex flex-wrap justify-content-start pe-0" id={"scrollmenu-activity" + index} style={{marginTop: '2px'}}>
            {data.activity.map((activity, idx) => (
                <span key={activity.id} className="text-dark">
                    <a
                        href={`/activity/${activity.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: 'blue' }}
                    >
                        {activity.name}
                    </a>
                    {idx !== data.activity.length - 1 && ',\u00A0'}
 {/* Add comma except for the last item */}
                </span>
            ))}
        </div>
    </Row>
) : null}


                                                                                {/* Tour End Message */}
                                                                                {/* {daily_plan.length - 1 === index ? (
                                                                                    <h6 style={{color: "darkgoldenrod", textAlign: "center"}}>
                                                                                        Tour Ends and we hope you will take memories and pleasant experiences.
                                                                                    </h6>
                                                                                ) : null} */}
                                                                            </CardBody>
                                                                        </Card>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <div className="timeline-item timeline-left pagebreak" key={`day-${data.day}`}>
                                                                    <div className="timeline-block">
                                                                        <Card className="timeline-box timeline-box-mobile backcolor">
                                                                            <CardBody>
                                                                                <span className="timeline-icon"></span>
                                                                                <div className="timeline-date timeline-date-new">
                                                                                    <i className="mdi mdi-circle-medium circle-dot"></i>
                                                                                    Day {data.day} ({this.getNextDays(itinerary.start_date, data.day-1)})
                                                                                </div>
                                                                                <div className='mt-3 timeline-image'>
                                                                                    <img 
                                                                                        src={`${BaseUrl}${data.current_location.image[0].image}`} 
                                                                                        style={{width: "100%", height: "100%" , objectFit: "cover"}}
                                                                                        alt={data.current_location.name}
                                                                                        className='rounded-2'
                                                                                    />
                                                                                </div>
                                                                                <h5 className="mt-3 underline-smallforheading" style={{ textAlign: 'left'}}>
                                                                                    {data.heading ? 
                                                                                        data.heading : 
                                                                                        (data.to_travel ?
                                                                                            `${data.current_location.name} to ${data.to_travel.name} (${calculateDistance(data.current_location.coordinates, data.to_travel.coordinates)} KM)`
                                                                                            :
                                                                                            `${data.current_location.name} Sight Seeing`)
                                                                                    }
                                                                                </h5>
                                                                                {data.comment === "" ? (
    <>
        {this.state[`expanded_${data.id}`] ? (
            <div style={{textAlign: 'left'}}>
                <p>
                    {data.to_travel 
                        ? data.to_travel.description 
                        : data.current_location.description}
                </p>
                <div className="text-start mt-1">
                    <Link 
                        to="#" 
                        onClick={() => this.setState(prevState => ({
                            [`expanded_${data.id}`]: !prevState[`expanded_${data.id}`]
                        }))}
                        className="text-primary"
                    >
                        Show Less
                    </Link>
                </div>
            </div>
        ) : (
            <div style={{textAlign: 'left'}}>
                <p style={{ 
                    overflow: 'hidden',
                    maxHeight: '3em',
                    lineHeight: '1.5em',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    marginBottom: '0',
                    wordBreak: 'break-word'
                }}>
                    {data.to_travel 
                        ? data.to_travel.description 
                        : data.current_location.description}
                </p>
                <div className="text-start mt-1">
                    <Link 
                        to="#" 
                        onClick={() => this.setState({ [`expanded_${data.id}`]: true })}
                        className="text-primary"
                    >
                        Read More
                    </Link>
                </div>
            </div>
        )}
    </>
) : (
    <>
        {this.state[`expanded_${data.id}`] ? (
            <div style={{textAlign: 'left'}}>
                <p>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: cleanHTML(data.comment),
                        }}
                    />
                </p>
                <div className="text-start mt-1">
                    <Link
                        to="#"
                        onClick={() =>
                            this.setState((prevState) => ({
                                [`expanded_${data.id}`]: !prevState[`expanded_${data.id}`],
                            }))
                        }
                        className="text-primary"
                    >
                        Show Less
                    </Link>
                </div>
            </div>
        ) : (
            <div style={{textAlign: 'left'}}>
                <p style={{ 
                    overflow: 'hidden',
                    maxHeight: '3em',
                    lineHeight: '1.5em',
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    marginBottom: '0',
                    wordBreak: 'break-word',
                }}>
                    <span
                        dangerouslySetInnerHTML={{
                            __html: cleanHTML(data.comment),
                        }}
                    />
                </p>
                {data.comment.length > 80 && (
                    <div className="text-start mt-1">
                        <Link
                            to="#"
                            onClick={() => this.setState({ [`expanded_${data.id}`]: true })}
                            className="text-primary"
                        >
                            Read More
                        </Link>
                    </div>
                )}
            </div>
        )}
    </>
)}



{data.hotels.length !== 0 ? (
    data.hotels.length > 1 ? (
        <Row>
            <Col>
             
                <h6 className="card-title mt-2 hotel-heading underline-small" style={{ textAlign: 'left' }}>{`Hotels and Stays:`}</h6>
                <div className="PrintStart gap-2 d-flex justify-content-start"

                    style={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                        overflowX: 'hidden',
                        maxWidth: '100%',
                        paddingBottom: '10px',

                        
                    }}
                >
                    {data.hotels.map((hotel) => {
                        return (
                            <Link
                                to="#"
                                className="me-2 text-dark text-center"
                                style={{
                                    flex: '0 0 33.33%',
                                    width: '100px',
                                    maxWidth: '31.5%',
                                }}
                                key={hotel.name}
                            >
                                <div className="d-flex flex-column align-items-center ">
                                    <img
                                        src={`${BaseUrl}${hotel.images[0].image}`}
                                        onClick={() =>
                                            this.onImageClick(hotel.images, hotel.name, hotel.description)
                                        }
                                        alt={hotel.name}
                                        className="rounded-2 hotel-image"
                                        style={{
                                            width: '100%',
                                            height: '90px',
                                            // maxHeight: '62px',
                                            objectFit: 'cover',
                                        }}
                                    />
                                    <p className="m-0 mt-1 hotel-name single-hotel-name text-start"

                                        style={{
                                            width: '100%',
                                            lineHeight: '1.2',
                                            textAlign: 'left',
                                        }}
                                    >
                                        {hotel.name}
                                    </p>
                                </div>
                            </Link>
                        );
                    })}
                </div>
            </Col>
        </Row>
    ) : (
        <Row>
        <Col>
        <h6 className="card-title mt-2 text-start hotel-heading underline-small" style={{textAlign: 'left'}}>
        {"Hotels and Stays:"}</h6>
        <div className="PrintStart d-flex gap-2 justify-content-start flex-column"

                style={{
                    maxWidth: '100%',
                    paddingBottom: '10px',
                }}
            >
                <div 
                // className="hotel-imageAlign "
                style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    overflowX: 'hidden',
                    justifyContent: 'left' ,
                    marginTop: '7px',
                    marginLeft: '-6px',

                }}
                >
                    {data.hotels[0].images.slice(0, 3).map((image, index) => {
                        return (
                            <Link
                                to="#"
                                className="ms-2 text-dark"
                                style={{
                                    flex: '0 0 33.33%',
                                    width: '100px',
                                    maxWidth: '31.5%',
                                }}
                                key={`${data.hotels[0].name}-img-${index}`}
                            >
                                <div className="d-flex flex-column align-items-center">

                                    <img
                                        src={`${BaseUrl}${image.image}`}
                                        onClick={() =>
                                            this.onImageClick(data.hotels[0].images, data.hotels[0].name, data.hotels[0].description)
                                        }
                                        alt={`${data.hotels[0].name}`}
                                        className="rounded-2 hotel-image " 
                                        style={{
                                            width: '100%',
                                            height: '90px',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>
                            </Link>
                        );
                    })}
                </div>
                <p
                  className="m-0 mt-1 hotel-name single-hotel-name text-start"

                  style={{
                    width: '100%',
                    lineHeight: '1.2',
                    textAlign: 'left',
                    wordWrap: 'break-word',
                    whiteSpace: 'normal',
                }}
                >
                    {data.hotels[0].name}
                </p>
            </div>
        </Col>
    </Row>
    
    )
) : null}


{/* Transportation Section */}
{(data.vehicle || data.multiple_vehicle?.length > 0) && (
    <Row>
        <h6 className="card-title mt-2 underline-smallfortransport" style={{ textAlign: 'left' }}>{`Transportation:`}</h6>
        {data.multiple_vehicle?.length > 1 ? (
            // Case: Multiple vehicles (more than one)
            <div
                className="PrintStart d-flex gap-2 justify-content-start"
                style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    overflowX: 'hidden',
                    width: '100%',
                    paddingBottom: '10px',
                }}
            >
                {data.multiple_vehicle.map((vehicle, index) => (
                    <Link
                        to="#"
                        className="me-2 text-dark text-center"
                        style={{
                            flex: '0 0 33.33%',
                            width: '100px',
                            maxWidth: '31.5%',
                        }}
                        key={`${vehicle.name || 'vehicle'}-${index}`}
                    >
                        <div className="d-flex flex-column align-items-center">
                            <img
                                src={`${BaseUrl}${vehicle.images?.[0]?.image}`}
                                onClick={() =>
                                    this.onImageClick(
                                        vehicle.images,
                                        vehicle.name,
                                        vehicle.description || ''
                                    )
                                }
                                alt={vehicle.name || 'Vehicle'}
                                className="rounded-2 vehicle-image"
                                style={{
                                    width: '100%',
                                    height: '90px',
                                    objectFit: 'cover',
                                }}
                            />
                            <p
                                className="m-0 mt-1 vehicle-name single-vehicle-name"
                                style={{
                                    width: '100%',
                                    lineHeight: '1.2',
                                    textAlign: 'left',
                                    wordWrap: 'break-word',
                                    whiteSpace: 'normal',
                                }}
                            >
                                {vehicle.name || 'Vehicle'}
                            </p>
                        </div>
                    </Link>
                ))}
            </div>
        ) : (
            // Case: Single vehicle
            <div
                className="PrintStart d-flex gap-2 justify-content-start flex-column"
                style={{
                    maxWidth: '100%',
                    paddingBottom: '10px',
                }}
            >
                <div
                    className="transport-mobile-view vehicle-imageAlign"
                    style={{
                        display: 'flex',
                        flexWrap: 'nowrap',
                        overflowX: 'hidden',
                        marginTop: '7px',
                        width: '100%',
                    }}
                >
                    {(data.multiple_vehicle?.length === 1 ? data.multiple_vehicle[0].images : data.vehicle?.images)
                        ?.slice(0, 3)
                        .map((image, imgIndex) => (
                            <Link
                                to="#"
                                className="ms-2 text-dark"
                                style={{
                                    flex: '0 0 33.33%',
                                    width: '100px',
                                    maxWidth: '31.5%',
                                }}
                                key={`${
                                    (data.multiple_vehicle?.length === 1
                                        ? data.multiple_vehicle[0].name
                                        : data.vehicle?.name) || 'vehicle'
                                }-img-${imgIndex}`}
                            >
                                <div className="d-flex flex-column align-items-center">
                                    <img
                                        src={`${BaseUrl}${image.image}`}
                                        onClick={() =>
                                            this.onImageClick(
                                                data.multiple_vehicle?.length === 1
                                                    ? data.multiple_vehicle[0].images
                                                    : data.vehicle.images,
                                                data.multiple_vehicle?.length === 1
                                                    ? data.multiple_vehicle[0].name
                                                    : data.vehicle.name,
                                                (data.multiple_vehicle?.length === 1
                                                    ? data.multiple_vehicle[0].description
                                                    : data.vehicle.description) || ''
                                            )
                                        }
                                        alt={
                                            (data.multiple_vehicle?.length === 1
                                                ? data.multiple_vehicle[0].name
                                                : data.vehicle?.name) || 'Vehicle'
                                        }
                                        className="rounded-2 vehicle-image"
                                        style={{
                                            width: '100%',
                                            height: '90px',
                                            objectFit: 'cover',
                                        }}
                                    />
                                </div>
                            </Link>
                        ))}
                </div>
                <p
                    className="m-0 mt-1 vehicle-name single-vehicle-name"
                    style={{
                        width: '100%',
                        lineHeight: '1.2',
                        textAlign: 'left',
                        wordWrap: 'break-word',
                        whiteSpace: 'normal',
                    }}
                >
                    {(data.multiple_vehicle?.length === 1
                        ? data.multiple_vehicle[0].name
                        : data.vehicle?.name) || 'Vehicle'}
                </p>
            </div>
        )}
    </Row>
)}
                                                                                {/* Places to Visit Section */}
                                                                                <Row>
                                                                                    <Col>
                                                                                        <h6 className="card-title mt-2 underline-small" style={{textAlign: 'left'}}>{"Places to Visit: "}</h6>
                                                                                        <div className="d-flex flex-column align-items-start ps-0 position-relative" style={{marginTop: '10px'}}>
                                                                                            <div className="textPara-fix"
                                                                                            //  d-flex flex-row-reverse flex-wrap gap-1"
                                                                                             >
                                                                                                {(() => {
                                                                                                    const placesToShow = [];
                                                                                                    
                                                                                                    // Add current location
                                                                                                    placesToShow.push(
                                                                                                        <a
                                                                                                            key={`current-${data.current_location.id}`}
                                                                                                            href={`/location/${data.current_location.id}`}
                                                                                                            target="_blank"
                                                                                                            rel="noopener noreferrer"
                                                                                                            className="text-dark text-decoration-none lh-1 p-0 m-0"
                                                                                                        >
                                                                                                            <p style={{ color: 'blue' }}>{data.current_location.name.substring(0, 12)}</p>
                                                                                                        </a>
                                                                                                    );
                                                                                                    
                                                                                                    // Add to_travel location if it exists
                                                                                                    if (data.to_travel) {
                                                                                                        placesToShow.unshift(
                                                                                                            <a
                                                                                                                key={`travel-${data.to_travel.id}`}
                                                                                                                href={`/location/${data.to_travel.id}`}
                                                                                                                target="_blank"
                                                                                                                rel="noopener noreferrer"
                                                                                                                className="text-dark text-decoration-none lh-1 p-0 m-0"
                                                                                                            >
                                                                                                                <p style={{ color: 'blue' }}>{data.to_travel.name.substring(0, 12)}</p>
                                                                                                            </a>
                                                                                                        );
                                                                                                    }
                                                                                                    
                                                                                                    // Add visiting places
                                                                                                    data.visiting_places.forEach(place => {
                                                                                                        if (place.id !== data.to_travel?.id && place.id !== data.current_location.id) {
                                                                                                            placesToShow.unshift(
                                                                                                                <a
                                                                                                                    key={`visit-${place.id}`}
                                                                                                                    href={`/location/${place.id}`}
                                                                                                                    target="_blank"
                                                                                                                    rel="noopener noreferrer"
                                                                                                                    className="text-dark text-decoration-none lh-1 p-0 m-0"
                                                                                                                >
                                                                                                                    <p style={{ color: 'blue' }}>{place.name}</p>
                                                                                                                </a>
                                                                                                            );
                                                                                                        }
                                                                                                    });
                                                                                                    
                                                                                                    // Join places with commas
                                                                                                    return placesToShow.map((place, index) => (
                                                                                                        <React.Fragment key={`fragment-${index}`}>
                                                                                                            {place}
                                                                                                            {index < placesToShow.length - 1 && <span className="me-1">,</span>}
                                                                                                        </React.Fragment>
                                                                                                    ));
                                                                                                })()}
                                                                                            </div>
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>

                                                                                {data.activity.length !== 0 ? (
    <Row>
        <h4 className="card-title mt-2 underline-smallfortransport padding-top" style={{textAlign: 'left'}}>{`Activities Today: `}</h4>
        <div  
            className="d-flex flex-wrap justify-content-start pe-0"
            style={{marginTop: '2px'}}
            id={"scrollmenu-activity" + index}
        >
            {[...data.activity].reverse().map((activity, idx) => (
                <span key={activity.id} className="text-dark" style={{ marginRight: '5px' }}>
                    <a
                        href={`/activity/${activity.id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: 'blue' }}
                    >
                        {activity.name}
                    </a>
                    {idx !== data.activity.length - 1 && ',\u00A0'}
{/* Add comma except for the last item */}
                </span>
            ))}
        </div>
    </Row>
) : null}


                                                                                {/* Tour End Message */}
                                                                                {/* {daily_plan.length - 1 === index ? (
                                                                                    <h6 style={{color: "darkgoldenrod", textAlign: "center"}}>
                                                                                        Tour Ends and we hope you will take memories and pleasant experiences.
                                                                                    </h6>
                                                                                ) : null} */}
                                                                            </CardBody>
                                                                        </Card>
                                                                    </div>
                                                                </div>
                                                            )
                                                        );
                                                    })}

                                                    {/* End Tour Timeline */}
                                                    <div className="timeline-left">
                                                        <div className="timeline-block">
                                                            <div className="time-show-btn mt-0">
                                                                <Link to="#" className="btn btn-primary btn-rounded w-lg Tourstartcolor">
                                                                    Tours End: {itinerary.drop_off_location ? itinerary.drop_off_location.name : ""}
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        {/* <div className='pagebreak mt-4'></div> */}

                                        {/* Additional Option */}
                                        <Row className="justify-content-center">
                                            <Col xl={10}>
                                                <div className="timeline" dir="ltr">
                                                    <div className="timeline-item timeline-left">
                                                        <div className="timeline-block">
                                                            <div className="time-show-btn mt-0">
                                                                <Link to="#" className="btn btn-warning btn-rounded w-lg">
                                                                    <b style={{color: 'black'}}>Additional Details</b>
                                                                </Link>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Payment Options */}
<div className="timeline-item pagebreak " ref={(ref) => this.myRef[0] = ref}>
    <div className="timeline-block paymentandTNCalign">
        <Card className="timeline-box timeline-box-mobile">
            <CardBody>
                <span className="timeline-icon"></span>
                <div className="timeline-date" style={{backgroundColor: '#4285f4'}}>
                    <b style={{color: 'white'}}><i className="mdi mdi-circle-medium circle-dot"></i> Payment Options</b>
                </div>
                
                <ul className="list-unstyled mb-4">
                    <li>
                        <h4 className="card-title mt-2">Bank Detail</h4>
                        <ul>
                            <li className='mt-4'>Account NO: {this.state.account_no}</li>
                            <li>IFSC Code: {this.state.ifsc}</li>
                        </ul>
                    </li>
                </ul>

                {this.state.isPaymentExpanded && (
                    <div className="expanded-content">
                        <ul className="list-unstyled mb-4">
                            <li>
                                <ul>
                                    <li>Account Name: {this.state.account_name}</li>
                                    <li>Bank Name: {this.state.bank_name}</li>
                                </ul>
                            </li>
                            <hr className="my-4" />
                            <li className='mt-4'>
                                <h4 className="card-title mt-2">UPI</h4>
                                <ul>
                                    <li className='mt-4'>Account Name: {this.state.account_name}</li>
                                    <li>UPI ID: {this.state.upi}</li>
                                </ul>
                            </li>
                            <hr className="my-4" />
                            <li className='mt-4'>
                                <h4 className="card-title mt-2">Online Payment</h4>
                                <ul>
                                    {itinerary.payment_url !== "" ? 
                                        <li><a target="_blank" rel="noreferrer" href={itinerary.payment_url}>Pay Now</a></li>
                                    :
                                        <li>Pay Now</li>
                                    }
                                </ul>
                            </li>
                            {itinerary.payment_note !== "" && (
                                <>
                                    <hr className="my-4" />
                                    <li className='mt-4'>
                                        <h4 className="card-title mt-2">Note</h4>
                                        <p>{itinerary.payment_note}</p>
                                    </li>
                                </>
                            )}
                        </ul>
                    </div>
                )}

                <Link 
                    to="#" 
                    onClick={() => this.setState({ isPaymentExpanded: !this.state.isPaymentExpanded })} 
                    className="me-3 mt-2 text-primary"
                >
                    {this.state.isPaymentExpanded ? "Read Less" : "Read More ..."}
                </Link>
            </CardBody>
        </Card>
    </div>
</div>

                                                    {/* Includes & Excludes */}
<div className="timeline-item timeline-left pagebreak" ref={(ref) => this.myRef[2] = ref}>
    <div className="timeline-block">
        <Card className="timeline-box timeline-box-mobile">
            <CardBody>
                <span className="timeline-icon"></span>
                <div className="timeline-date" style={{backgroundColor: '#4285f4'}}>
                    <b style={{color: 'white'}}><i className="mdi mdi-circle-medium circle-dot"></i> Includes & Excludes</b>
                </div>
                
                <ul className="list-unstyled mb-4">
                    {!this.state.isIncludesExpanded ? (
                        // Show only the first 2 points when collapsed
                        <>
                            <li>
                                <h4 className="card-title mt-2">Tour Package Includes</h4>
                                <ul>
                                    {inclusitions.slice(0, 2).map((include, index) => (
                                        <p key={`incl-${index}`}><b>PI{index + 1}. </b>{include.point.substring(0, 80)}</p>
                                    ))}
                                </ul>
                            </li>
                            <li className='mt-4'>
                                <h4 className="card-title mt-2">Tour Package Excludes</h4>
                                <ul>
                                    {exclusitions.slice(0, 2).map((exclude, index) => (
                                        <p key={`excl-${index}`}><b>PE{index + 1}. </b>{exclude.point.substring(0, 80)}</p>
                                    ))}
                                </ul>
                            </li>
                        </>
                    ) : (
                        // Show full list when expanded
                        <>
                            <li>
                                <h4 className="card-title mt-2">Tour Package Includes</h4>
                                <ul>
                                    {inclusitions.map((include, index) => (
                                        <p key={`incl-full-${index}`}><b>PI{index + 1}. </b>{include.point}</p>
                                    ))}
                                </ul>
                            </li>
                            <li className='mt-4'>
                                <h4 className="card-title mt-2">Tour Package Excludes</h4>
                                <ul>
                                    {exclusitions.map((exclude, index) => (
                                        <p key={`excl-full-${index}`}><b>PE{index + 1}. </b>{exclude.point}</p>
                                    ))}
                                </ul>
                            </li>
                        </>
                    )}
                </ul>

                {(inclusitions.length > 2 || exclusitions.length > 2) && (
                    <Link 
                        to="#" 
                        onClick={() => this.setState({ isIncludesExpanded: !this.state.isIncludesExpanded })} 
                        className="me-3 text-primary"
                    >
                        {this.state.isIncludesExpanded ? "Read Less" : "Read More ..."}
                    </Link>
                )}
            </CardBody>
        </Card>
    </div>
</div>


                                                    {/* Terms & Conditions */}
                                                    <div className="timeline-item pagebreak " ref={(ref) => (this.myRef[3] = ref)}>
        <div className="timeline-block paymentandTNCalign">
          <Card className="timeline-box timeline-box-mobile">
            <CardBody>
              <span className="timeline-icon"></span>
              <div className="timeline-date" style={{backgroundColor: '#4285f4'}}>
                <b style={{ color: 'white' }}>
                  <i className="mdi mdi-circle-medium circle-dot"></i> Terms & Conditions
                </b>
              </div>

              {!this.state.isTermsExpanded ? (
                <ul className="list-unstyled mb-4">
                  <li className="mt-4">
                    <ul>
                      {terms_condition.slice(0, 2).map((condition, index) => (
                        <p key={`tc-${index}`}>
                          <b>TC-{index + 1}: </b>
                          {condition.point.substring(0, 80)}...
                        </p>
                      ))}
                    </ul>
                  </li>
                </ul>
              ) : (
                <div className="expanded-content">
                  <ul className="list-unstyled mb-4">
                    <li className="mt-4">
                      <ul>
                        {terms_condition.map((condition, index) => (
                          <p key={`tc-full-${index}`}>
                            <b>TC-{index + 1}: </b>
                            {condition.point}
                          </p>
                        ))}
                      </ul>
                    </li>
                  </ul>
                </div>
              )}

              {terms_condition.length > 2 && (
                <Link
                  to="#"
                  onClick={() => this.setState({ isTermsExpanded: !this.state.isTermsExpanded })}
                  className="me-3 text-primary"
                >
                  {this.state.isTermsExpanded ? 'Read Less' : 'Read More ...'}
                </Link>
              )}
            </CardBody>
          </Card>
        </div>
      </div>
                                                    {/* Tour Contacts */}
                                                    <div className="timeline-item timeline-left" ref={(ref) => this.myRef[1] = ref}>
                                                        <div className="timeline-block">
                                                            <Card className="timeline-box timeline-box-mobile">
                                                                <CardBody>
                                                                    <span className="timeline-icon"></span>
                                                                    <div className="timeline-date" style={{backgroundColor: '#4285f4'}}>
                                                                        <b style={{color: 'white'}}><i className="mdi mdi-circle-medium circle-dot"></i> Tour Contacts</b>
                                                                    </div>
                                                                    <div className="card-title mt-2">
                                                                        <p>{signature?.name}</p>
                                                                        <p>{signature?.designation}</p>
                                                                        <p>{signature?.address}</p>
                                                                        <p>{itinerary.status === 'tour booked' ? signature?.phone : "**********"}</p>
                                                                        <p>{itinerary.status === 'tour booked' ? signature?.email : signature ? `*****@${signature.email.split('@')[1]}` : "*****@gmail.com"}</p>
                                                                        <a href={`https://${signature?.website}`} target="_blank" rel="noreferrer">{signature?.website}</a>
                                                                    </div>  
                                                                </CardBody>
                                                            </Card>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>

                                    {/* Modals */}
                                    {/* About Modal */}
                                    <Col sm={6} md={4} xl={3} className="mt-4">
                                        <Modal
                                            isOpen={this.state.modal_center}
                                            toggle={this.tog_center}
                                            centered={true}
                                        >
                                            <ModalHeader toggle={() => this.setState({ modal_center: false })}>
                                                {this.state.heading}
                                            </ModalHeader>
                                            <ModalBody>
                                                <p>{this.state.desc}</p>
                                                {(this.state.time_plan).length > 0 ? (
                                                    <>
                                                        <hr />
                                                        {this.state.time_plan.map((plan, idx) => {
                                                            return (
                                                                <p key={`plan-${idx}`}><b>{Moment(new Date(`2022-10-01T${plan.time}`)).format('LT')}: </b>{(plan.plan)}</p>
                                                            );
                                                        })}
                                                    </>
                                                ) : null}
                                            </ModalBody>
                                        </Modal>
                                    </Col>

                                    {/* Terms and Condition Modal */}
                                    <Col sm={6} md={4} xl={3} className="mt-4">
                                        <Modal
                                            isOpen={this.state.modal_terms}
                                            toggle={this.tog_terms}
                                            scrollable={true}
                                        >
                                            <ModalHeader toggle={() => this.setState({ modal_terms: false })}>
                                                Terms & Conditions
                                            </ModalHeader>
                                            <ModalBody>
                                                <ul className="list-unstyled mb-4">
                                                    <li className='mt-4'>
                                                        <ul>
                                                            {terms_condition.map((condition, index) => {
                                                                return (<p key={`tc-modal-${index}`}><b>TC-{index+1}: </b>{condition.point}</p>);
                                                            })}
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </ModalBody>
                                        </Modal>
                                    </Col>

                                    {/* Modal For Inclusion and Exclusion */}
                                    <Col sm={6} md={4} xl={3} className="mt-4">
                                        <Modal
                                            isOpen={this.state.modal_inc_exc}
                                            toggle={this.tog_inc_exc}
                                            scrollable={true}
                                        >
                                            <ModalHeader toggle={() => this.setState({ modal_inc_exc: false })}>
                                                Package Includes and Excludes
                                            </ModalHeader>
                                            <ModalBody>
                                                <ul className="list-unstyled mb-4">
                                                    <li>
                                                        <h4 className="card-title mt-2">{"Tour Package Includes"}</h4>
                                                        <ul>
                                                            {inclusitions.map((include, index) => {
                                                                return (<p key={`incl-modal-${index}`}><b>PI{index+1}. </b>{include.point}</p>);
                                                            })}
                                                        </ul>
                                                    </li>
                                                    <li className='mt-4'>
                                                        <h4 className="card-title mt-2">{"Tour Package Excludes"}</h4>
                                                        <ul>
                                                            {exclusitions.map((exclude, index) => {
                                                                return (<p key={`excl-modal-${index}`}><b>PE{index+1}. </b>{exclude.point}</p>);
                                                            })}
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </ModalBody>
                                        </Modal>
                                    </Col>
                                    
                                    {/* Payment Options Modal */}
                                    <Col sm={6} md={4} xl={3} className="mt-4">
                                        <Modal
                                            isOpen={this.state.modal_payment}
                                            toggle={this.tog_payment}
                                            scrollable={true}
                                        >
                                            <ModalHeader toggle={() => this.setState({ modal_payment: false })}>
                                                Payment Options
                                            </ModalHeader>
                                            <ModalBody>
                                                <ul className="list-unstyled mb-4">
                                                    <li>
                                                        <h4 className="card-title mt-2">{"Bank Detail "}</h4>
                                                        <ul>
                                                            <li className='mt-4'>Account Name: {this.state.account_name}</li>
                                                            <li>Account NO: {this.state.account_no}</li>
                                                            <li>IFSC Code: {this.state.ifsc}</li>
                                                            <li>Bank Name: {this.state.bank_name}</li>
                                                        </ul>
                                                    </li>
                                                    <hr className="my-4" />
                                                    <li className='mt-4'>
                                                        <h4 className="card-title mt-2">{"UPI"}</h4>
                                                        <ul>
                                                            <li className='mt-4'>Account Name: {this.state.account_name}</li>
                                                            <li>UPI ID: {this.state.upi}</li>
                                                        </ul>
                                                    </li>
                                                    <hr className="my-4" />
                                                    <li className='mt-4'>
                                                        <h4 className="card-title mt-2">{"Online Payment"}</h4>
                                                        <ul>
                                                            {itinerary.payment_url !== "" ? 
                                                                <li><a target="_blank" rel="noreferrer" href={itinerary.payment_url}>Pay Now</a></li>
                                                            :
                                                                <li>Pay Now</li>
                                                            }
                                                        </ul>
                                                    </li>
                                                    {itinerary.payment_note !== "" ? (
                                                        <>
                                                            <hr className="my-4" />
                                                            <li className='mt-4'>
                                                                <h4 className="card-title mt-2">{"Note"}</h4>
                                                                <p>{itinerary.payment_note}</p>
                                                            </li>
                                                        </>
                                                    ) : ""}
                                                </ul>
                                            </ModalBody>
                                        </Modal>
                                    </Col>

                                    {/* Color Picker Modal */}
                                    <Col sm={6} md={4} xl={3} className="mt-4">
                                        <Modal
                                            isOpen={this.state.modal_color_picker}
                                            toggle={this.tog_color_picker}
                                            scrollable={true}
                                        >
                                            <ModalHeader toggle={this.tog_color_picker}>
                                                Select Background Color
                                            </ModalHeader>
                                            <ModalBody>
                                                <Row>
                                                    <Col md={6}>
                                                        <FormGroup className="m-b-0">
                                                            <Label className="form-label">As a component</Label>
                                                            <InputGroup className="colorpicker-default" title="Using format option">
                                                                <InputGroupAddon addonType="append">
                                                                    <span
                                                                        className="input-group-text colorpicker-input-addon"
                                                                        style={{width: '100px'}}
                                                                        onClick={() => this.setState({ simple_color1: !this.state.simple_color1 })}
                                                                    >
                                                                        <i style={{
                                                                            height: "16px",
                                                                            width: "100px",
                                                                            background: this.state.backgroundColor
                                                                        }}></i>
                                                                    </span>
                                                                </InputGroupAddon>
                                                            </InputGroup>
                                                        </FormGroup>
                                                    </Col>
                                                    <Col md={6}>
                                                        {this.state.simple_color1 ?
                                                            <ColorPicker saturationHeight={100} saturationWidth={100} value={this.state.backgroundColor} onDrag={this.onDragRgb.bind(this)} />
                                                        : null}
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    {this.state.loading ?
                                                        <Spinner className="me-2 mt-3 float-end" color="primary" />
                                                    :
                                                        <div className="text-center mt-3 float-end">
                                                            <Button type="submit" color="primary" className="me-1" onClick={this.SaveBackgroundColor}>
                                                                Submit
                                                            </Button>
                                                        </div>
                                                    }
                                                </Row>
                                            </ModalBody>
                                        </Modal>
                                    </Col>

                                    {/* Share Modal */}
                                    <Col sm={6} md={4} xl={3} className="mt-4">
                                        <Modal
                                            isOpen={this.state.modal_share}
                                            toggle={this.tog_share}
                                            centered={true}
                                        >
                                            <ModalHeader toggle={this.tog_share}>
                                                Share Itinerary
                                            </ModalHeader>
                                            <ModalBody>
                                                <Nav tabs className="nav-tabs-custom nav-justified">
                                                    <NavItem>
                                                        <NavLink
                                                            style={{ cursor: "pointer" }}
                                                            className={classnames({
                                                                active: this.state.activeTabJustify === "5"
                                                            })}
                                                            onClick={() => {
                                                                this.toggleCustomJustified("5");
                                                            }}
                                                        >
                                                            <span><span><i className="ri-mail-send-line"> Via Email</i></span></span>
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink
                                                            style={{ cursor: "pointer" }}
                                                            className={classnames({
                                                                active: this.state.activeTabJustify === "6"
                                                            })}
                                                            onClick={() => {
                                                                this.toggleCustomJustified("6");
                                                            }}
                                                        >
                                                            <span><i className="fab fa-whatsapp"> Via WhatsApp</i></span>
                                                        </NavLink>
                                                    </NavItem>
                                                    <NavItem>
                                                        <NavLink
                                                            style={{ cursor: "url" }}
                                                            className={classnames({
                                                                active: this.state.activeTabJustify === "7"
                                                            })}
                                                            onClick={() => {
                                                                this.toggleCustomJustified("7");
                                                            }}
                                                        >
                                                            <span><i className=" far fa-copy"> URL</i></span>
                                                        </NavLink>
                                                    </NavItem>
                                                </Nav>

                                                <TabContent activeTab={this.state.activeTabJustify}>
                                                    <TabPane tabId="5" className="p-3">
                                                        <AvForm className="needs-validation" onValidSubmit={this.handleSubmit}>
                                                            <Row>
                                                                <Col md={12}>
                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="user_email">Email</Label>
                                                                        <AvField
                                                                            name="email"
                                                                            value={itinerary.email}
                                                                            type="email"
                                                                            errorMessage="Enter Customer Name"
                                                                            className="form-control"
                                                                            validate={{ required: { value: true } }}
                                                                            id="user_email"
                                                                        />
                                                                    </div>
                                                                </Col> 
                                                            </Row>
                                                            <Row>
                                                                <Col md={12}>
                                                                    <div className="mb-3">
                                                                        <Label className="form-label" htmlFor="subject">Subject</Label>
                                                                        <AvField
                                                                            name="subject"
                                                                            type="text"
                                                                            errorMessage="Enter Subject Name"
                                                                            className="form-control"
                                                                            value={itinerary.title.split("Ex")[0]}
                                                                            validate={{ required: { value: true } }}
                                                                            id="subject"
                                                                        />
                                                                    </div>
                                                                </Col> 
                                                            </Row>
                                                            <Row>
                                                                <Editor       
                                                                    toolbar={{
                                                                        options: ['inline','fontSize', 'fontFamily','link'],
                                                                        inline: {
                                                                            options: ['bold', 'italic', 'underline'],
                                                                        },
                                                                    }}      
                                                                    initialEditorState={this.state.editorState}                   
                                                                    toolbarClassName="toolbarClassName"
                                                                    wrapperClassName="wrapperClassName"
                                                                    editorClassName="editorClassName"
                                                                    onEditorStateChange={this.onEditorStateChange}
                                                                />
                                                            </Row>
                                                            <Row>
                                                                <Col md="6">
                                                                    {this.state.loading ?
                                                                        <Spinner className="me-2 mt-3" color="primary" />
                                                                    :
                                                                        <div className="mt-3">
                                                                            <Button type="submit" color="primary">
                                                                                Share
                                                                            </Button>
                                                                        </div>
                                                                    }
                                                                </Col>
                                                            </Row>
                                                        </AvForm>
                                                    </TabPane>
                                                    
                                                    <TabPane tabId="6" className="p-3">
                                                        <div className='d-flex align-items-center justify-content-center'>
                                                            <WhatsappShareButton
                                                                windowWidth="1024"
                                                                windowHeight={"800"}
                                                                from=""
                                                                url={`${BaseUrl}/itinerary/${itinerary.id}/${createSlugfromName(itinerary.name)}`}
                                                                title={itinerary.title.split("Ex")[0]}
                                                                separator="::"
                                                                className="Demo__some-network__share-button"
                                                            >
                                                                <WhatsappIcon size={50} round={true} />
                                                            </WhatsappShareButton>
                                                        </div>
                                                    </TabPane>
                                                    <TabPane tabId="7" className="p-3">
                                                        <Row>
                                                            <Col md={12}>
                                                                <AvForm>
                                                                    <div className="mb-3">
                                                                        <AvField
                                                                            name="url_link"
                                                                            type="text"
                                                                            errorMessage="Enter Subject Name"
                                                                            className="form-control"
                                                                            value={`${BaseUrl}/itinerary/${itinerary.id}/${createSlugfromName(itinerary.name)}`}
                                                                            disabled
                                                                            id="url_link"
                                                                        />
                                                                    </div>
                                                                </AvForm>
                                                            </Col> 
                                                        </Row>
                                                        <Row>
                                                            <Link to="#" onClick={() => {
                                                                navigator.clipboard.writeText(`${BaseUrl}/itinerary/${itinerary.id}/${createSlugfromName(itinerary.name)}`);
                                                                toastr.success("URL Copied on Clip Board")
                                                            }} className="text-dark">
                                                                <i className="far fa-copy font-size-30 float-end"> Copy URL</i>
                                                            </Link>
                                                        </Row>
                                                    </TabPane>
                                                </TabContent>
                                            </ModalBody>
                                        </Modal>
                                    </Col>
                                </Container>
                            ) : (
                                <Container fluid={true}>
                                    <Col sm={6} md={4} xl={3} className="mt-4">
                                        <Modal
                                            isOpen={true}
                                            toggle={() => {this.props.history.push('/404')}}
                                        >
                                            <ModalHeader toggle={() => {this.props.history.push('/404')}}>
                                                Enter password 
                                            </ModalHeader>
                                            <ModalBody>
                                                <AvForm className="needs-validation" onValidSubmit={this.HandleValidateUserSubmit}>
                                                    <Row>
                                                        <Col xs={12}>
                                                            <Row className="mb-3">
                                                                <Label className="col-md-2 col-form-label" htmlFor="password">Password</Label>
                                                                <Col md={8}>
                                                                    <AvField
                                                                        name="password"
                                                                        type="text"
                                                                        errorMessage="Enter Password"
                                                                        className="form-control"
                                                                        validate={{ required: { value: true } }}
                                                                        id="password"
                                                                    /> 
                                                                    <p><span style={{color:"red"}}>*</span>Hint: Password is your mobile number.</p>
                                                                </Col>
                                                            </Row> 
                                                        </Col>      
                                                    </Row>
                                                                
                                                    <FormGroup className="mb-0 float-end">
                                                        {this.state.password_loading ? (
                                                            <Spinner className="me-2 mt-2" color="primary" />
                                                        ) : (
                                                            <div>
                                                                <Button type="submit" color="primary" className="me-1">Submit</Button>
                                                            </div>
                                                        )}
                                                    </FormGroup>     
                                                </AvForm>
                                            </ModalBody>
                                        </Modal>
                                    </Col>
                                </Container>
                            )
                        ) : (
                            <Container>
                                <Breadcrumbs title={itinerary.title} breadcrumbItems={[]} />
                                
                                {/* Print-only header */}
                                {print && (
                                    <div className="print-only print-header">
                                        <div className="print-logo">
                                            {signature && signature.logo ? (
                                                <img src={signature.logo || "/placeholder.svg"} alt="Company Logo" style={{ maxWidth: '150px' }} />
                                            ) : (
                                                <h3>Planmans</h3>
                                            )}
                                        </div>
                                        <div className="print-title">
                                            {itinerary.title}
                                        </div>
                                        <div className="print-date">
                                            Printed on: {currentDate}
                                        </div>
                                    </div>
                                )}
                                
                                <div id="timeLine">
                                    <Row>
                                        <Col lg={12}>
                                            <Card style={{backgroundColor: this.state.backgroundColor}}>
                                                <button onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})} id="top-btn" title="Go to top" className="no-print">
                                                    <i className="fas fa-angle-up font-size-18"></i>
                                                </button>
                                                <CardBody>
                                                    <Row>
                                                        <Col lg={6}>
                                                            <div className="text-center align-items-center justify-content-center">
                                                                <h1 className="mt-4" style={{color: "white"}}>{itinerary.name}</h1>
                                                                <h4 className="mt-4 mb-4" style={{color: "white"}}>{startDate} - {endDate}</h4>
                                                            </div>
                                                        </Col>
                                                        <Col lg={6}>
                                                            <div className="text-center align-items-center justify-content-center">
                                                                <p style={{fontSize: "large", color: "white"}}>
                                                                    <b className='bold'>{"Package Type: "}</b>{itinerary.packege}
                                                                </p>
                                                                <p style={{fontSize: "large", color: "white"}}>
                                                                    <b className='bold'>{"Destinations: "}</b>
                                                                    {itinerary.destinations.map((destini, index) => {
                                                                        return ((itinerary.destinations).length-1 === index ? 
                                                                            destini.name : destini.name+", ")
                                                                    })}
                                                                </p>
                                                                <p style={{fontSize: "large", color: "white"}}>
                                                                    <b className='bold'>{"No of PAX: "}</b>
                                                                    {adults} Adults{teens !== 0 ? `, ${teens} Teens` : ""}
                                                                    {kids !== 0 ? `, ${kids} Kids` : ""}
                                                                </p>
                                                                <p style={{fontSize: "large", color: "white"}}>
                                                                    <b className='bold'>{"Meal Plan: "}</b>{"MAP"}
                                                                </p>
                                                                <p style={{fontSize: "large", color: "white"}}>
                                                                    <b className='bold'>{"Total Cost: "}</b>₹ {this.formatCurrency(itinerary.pkg_const_margin.toFixed(2))}
                                                                </p>
                                                                <p style={{fontSize: "large", color: "white"}}>
                                                                    <b className='bold'>{"Per PAX Cost: "}</b>₹ {this.formatCurrency((itinerary.pkg_const_margin / itinerary.pax).toFixed(2))}
                                                                </p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>
                                    </Row>
                                    
                                    <div className=' mt-4'></div>
                                    
                                    <Row className="justify-content-center mt-2">
                                        <Col xl={10}>
                                            <div className="timeline" dir="ltr">
                                                <div className="timeline-item timeline-left pagebreakavoid">
                                                    <div className="timeline-block">
                                                        <div className="time-show-btn mt-0 ">
                                                            <Link to="#" className="btn btn-primary btn-rounded w-lg Tourstartcolor">
                                                                Tour Starts: {itinerary.pick_up_location ? itinerary.pick_up_location.name : ""}
                                                            </Link>
                                                        </div>
                                                    </div>
                                                </div>

                                                {daily_plan.map((data, index) => {
                                                    return (
                                                        (index+2) % 2 === 0 ? (
                                                            <div className="mt-4 timeline-item pagebreak" key={`day-${data.day}`}>
                                                                <div className="timeline-block">
                                                                    <Card className="timeline-box timeline-box-mobile">
                                                                        <CardBody>
                                                                            <span className="timeline-icon"></span>
                                                                            <div className="timeline-date timeline-date-new">
                                                                                <i className="mdi mdi-circle-medium circle-dot"></i>
                                                                                Day {data.day} ({this.getNextDays(itinerary.start_date, data.day-1)})
                                                                            </div>
                                                                            <div className='mt-3 timeline-image'>
                                                                                <img 
                                                                                    src={`${BaseUrl}${data.current_location.image[0].image}`} 
                                                                                    style={{width: "100%", height: "100%" , objectFit: "cover"}}
                                                                                    alt={data.current_location.name}
                                                                                    className='rounded-2'
                                                                                />
                                                                            </div>
                                                                            <div className='m-4'>
                                                                                <h5 className="mt-3" style={{'fontSize': "1rem"}}>
                                                                                    {data.heading ? 
                                                                                        data.heading : 
                                                                                        (data.to_travel ?
                                                                                            `${data.current_location.name} to ${data.to_travel.name} (${calculateDistance(data.current_location.coordinates, data.to_travel.coordinates)} KM)`
                                                                                            :
                                                                                            `${data.current_location.name} Sight Seeing`)
                                                                                    }
                                                                                </h5>
                                                                                <div className="text-muted">
                                                                                    {data.comment === "" ?
                                                                                        <p>{data.to_travel ? `${(data.to_travel.description)} ` : `${(data.current_location.description)} `}</p>
                                                                                    :
                                                                                        <p>{data.comment}</p>
                                                                                    }
                                                                                </div>
                                                                                
                                                                                {/* Hotels and Stays Section */}
                                                                                {data.hotel ?
                                                                                    <Row>
                                                                                        <Col>
                                                                                            <h4 className="card-title mt-2">{`Hotels and Stays: ${data.hotel.name}`}</h4>
                                                                                            <div className="scrollmenu d-flex flex-wrap gap-2" id={"scrollmenu-hotel"+index} onWheel={(e) => this.onWheel(e, "scrollmenu-hotel"+index)}>
                                                                                                {data.hotel.images.map((image, idx) => {
                                                                                                    return (
                                                                                                        <Link to="#" className="me-2 text-dark" key={`hotel-img-${idx}`}>
                                                                                                            <img
                                                                                                                src={`${BaseUrl}${image.image}`}
                                                                                                                onClick={() => this.onImageClick(data.hotel.images, data.hotel.name, data.hotel.description)}
                                                                                                                alt={data.hotel.name}
                                                                                                                className='rounded-2'
                                                                                                            />
                                                                                                            <p className="m-0 mt-1">{(image.name)}</p>
                                                                                                        </Link>
                                                                                                    );
                                                                                                })}    
                                                                                            </div>
                                                                                        </Col>
                                                                                    </Row>
                                                                                : null}
                                                                                
                                                                                {/* Transportation Section */}
                                                                                {data.vehicle ?
                                                                                    <Row>
                                                                                        <h4 className="card-title mt-2 underline-smallfortransport">{`Transportation:`}</h4>
                                                                                        <div className="d-flex flex-wrap gap-2">
                                                                                            {data.vehicle.images.map((image, idx) => {
                                                                                                return (
                                                                                                    <Link to="#" className="me-2 text-dark" key={`vehicle-img-${idx}`}>
                                                                                                        <img
                                                                                                            src={`${BaseUrl}${image.image}`}
                                                                                                            onClick={() => this.onImageClick(data.vehicle.images, data.vehicle.name, data.vehicle.description)}
                                                                                                            alt={image.name}
                                                                                                            className='rounded-2'
                                                                                                            style={{ width: "100px", height: "62px", objectFit: "cover" }}
                                                                                                        />
                                                                                                        <p className="m-0 mt-1" style={{ width: "100px", whiteSpace: "normal", lineHeight: "1.2", wordWrap: "break-word" }}>
                                                                                                            {(data.vehicle.name)}
                                                                                                        </p>
                                                                                                    </Link>
                                                                                                );
                                                                                            })}
                                                                                        </div>
                                                                                    </Row>
                                                                                : null}
                                                                                
                                                                                {/* Places to Visit Section */}
                                                                                <Row>
                                                                                    <Col>
                                                                                        <h4 className="card-title mt-2 underline-small">{"Places to Visit: "}</h4>
                                                                                        <div
                                                                                            className="d-flex flex-row-reverse flex-wrap pe-2 ps-0 align-items-center"
                                                                                            id={"scrollmenu" + index}
                                                                                            style={{ minHeight: "10px", marginTop: '10px'}}
                                                                                        >
                                                                                            {(() => {
                                                                                                const placesToShow = [];
                                                                                                
                                                                                                // Add current location
                                                                                                placesToShow.push(
                                                                                                    <a
                                                                                                        key={`current-${data.current_location.id}`}
                                                                                                        href={`/location/${data.current_location.id}`}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                        className="text-dark lh-1 p-0 m-0"
                                                                                                    >
                                                                                                        <p style={{ color: 'blue' }}>{data.current_location.name}</p>
                                                                                                    </a>
                                                                                                );
                                                                                                
                                                                                                // Add to_travel location if it exists
                                                                                                if (data.to_travel && data.to_travel.image[0]) {
                                                                                                    placesToShow.unshift(
                                                                                                        <a
                                                                                                            key={`travel-${data.to_travel.id}`}
                                                                                                            href={`/location/${data.to_travel.id}`}
                                                                                                            target="_blank"
                                                                                                            rel="noopener noreferrer"
                                                                                                            className="text-dark lh-1 p-0 m-0"
                                                                                                        >
                                                                                                            <p style={{ color: 'blue' }}>{data.to_travel.name}</p>
                                                                                                        </a>
                                                                                                    );
                                                                                                }
                                                                                                
                                                                                                // Add other visiting places
                                                                                                data.visiting_places.forEach(place => {
                                                                                                    if (place.id !== data.to_travel?.id && place.id !== data.current_location.id && place.image[0]) {
                                                                                                        placesToShow.unshift(
                                                                                                            <a
                                                                                                                key={`visit-${place.id}`}
                                                                                                                href={`/location/${place.id}`}
                                                                                                                target="_blank"
                                                                                                                rel="noopener noreferrer"
                                                                                                                className="text-dark lh-1 p-0 m-0"
                                                                                                            >
                                                                                                                <p style={{ color: 'blue' }}>{place.name}</p>
                                                                                                            </a>
                                                                                                        );
                                                                                                    }
                                                                                                });
                                                                                                
                                                                                                // Join places with commas
                                                                                                return placesToShow.map((place, index) => (
                                                                                                    <React.Fragment key={`fragment-${index}`}>
                                                                                                        {place}
                                                                                                        {index < placesToShow.length - 1 && <span className="me-1">,</span>}
                                                                                                    </React.Fragment>
                                                                                                ));
                                                                                            })()}
                                                                                        </div>
                                                                                    </Col>
                                                                                </Row>

                                                                                {/* Activities Section */}
                                                                                {data.activity.length !== 0 ?
                                                                                    <Row>
                                                                                        <h4 className="card-title mt-2 underline-smallfortransport">{`Activities Today: `}</h4>
                                                                                        <div  
                                                                                            className="d-flex flex-wrap justify-content-start justify-content-lg-end pe-0"
                                                                                            style={{ maxHeight: '100px', overflowY: 'auto', marginTop: '2px'}}
                                                                                            id={"scrollmenu-activity" + index}
                                                                                        >
                                                                                            {[...data.activity].reverse().map((activity, idx) => (
                                                                                                <span key={activity.id} className="text-dark" style={{ marginRight: '5px'}}>
                                                                                                    <a
                                                                                                        href={`/activity/${activity.id}`}
                                                                                                        target="_blank"
                                                                                                        rel="noopener noreferrer"
                                                                                                        style={{ color: 'blue' }}
                                                                                                    >
                                                                                                        {activity.name}
                                                                                                    </a>
                                                                                                    {idx !== data.activity.length - 1 && ',\u00A0'}
 {/* Add comma except for the last item */}
                                                                                                </span>
                                                                                            ))}
                                                                                        </div>
                                                                                    </Row>
                                                                                : null}

                                                                                {/* Tour End Message */}
                                                                                {/* {daily_plan.length - 1 === index ?
                                                                                    <h6 style={{color: "darkgoldenrod", textAlign: "center"}}>
                                                                                        Tour Ends and we hope you will take memories and pleasant experiences.
                                                                                    </h6>
                                                                                : null} */}
                                                                            </div>
                                                                        </CardBody>
                                                                    </Card>
                                                                </div>
                                                            </div>
                                                        ) : (
                                                            <div className="pagebreak mt-4 timeline-item timeline-left" key={`day-${data.day}`}>
                                                                <div className="timeline-block">
                                                                    <Card className="timeline-box timeline-box-mobile">
                                                                        <CardBody>
                                                                            <span className="timeline-icon"></span>
                                                                            <div className="timeline-date timeline-date-new">
                                                                                <i className="mdi mdi-circle-medium circle-dot"></i>
                                                                                Day {data.day} ({this.getNextDays(itinerary.start_date, data.day-1)})
                                                                            </div>
                                                                            <div className='mt-3 timeline-image'>
                                                                                <img 
                                                                                    src={`${BaseUrl}${data.current_location.image[0].image}`} 
                                                                                    style={{width: "100%", height: "100%", objectFit: "cover"}}
                                                                                    alt={data.current_location.name}
                                                                                    className='rounded-2'
                                                                                />
                                                                            </div>
                                                                            <div className='m-4'>
                                                                                <h5 className="mt-3" style={{'fontSize': "1rem"}}>
                                                                                    {data.heading ? 
                                                                                        data.heading : 
                                                                                        (data.to_travel ?
                                                                                            `${data.current_location.name} to ${data.to_travel.name} (${calculateDistance(data.current_location.coordinates, data.to_travel.coordinates)} KM)`
                                                                                            :
                                                                                            `${data.current_location.name} Sight Seeing`)
                                                                                    }
                                                                                </h5>
                                                                                <div className="text-muted">
                                                                                    {data.comment === "" ? (
                                                                                        <>
                                                                                            {this.state[`expanded_${data.id}`] ? (
                                                                                                <p>
                                                                                                    {data.to_travel ? data.to_travel.description : data.current_location.description}
                                                                                                    <Link 
                                                                                                        to="#" 
                                                                                                        onClick={() => this.setState(prevState => ({ 
                                                                                                            [`expanded_${data.id}`]: !prevState[`expanded_${data.id}`] 
                                                                                                        }))} 
                                                                                                        className="d-block mt-0 text-primary"
                                                                                                    >
                                                                                                        Show Less
                                                                                                    </Link>
                                                                                                </p>
                                                                                            ) : (
                                                                                                <p>
                                                                                                    {data.to_travel 
                                                                                                        ? `${(data.to_travel.description).substring(0, 110)} ` 
                                                                                                        : `${(data.current_location.description).substring(0, 110)} `}
                                                                                                    <Link 
                                                                                                        to="#" 
                                                                                                        onClick={() => this.setState({ [`expanded_${data.id}`]: true })} 
                                                                                                        className="me-3 text-primary"
                                                                                                    >
                                                                                                        Read More ...
                                                                                                    </Link>
                                                                                                </p>
                                                                                            )}
                                                                                        </>
                                                                                    ) : (
                                                                                        <>
                                                                                            {this.state[`expanded_${data.id}`] ? (
                                                                                                <p>
                                                                                                    {data.comment}
                                                                                                    <Link 
                                                                                                        to="#" 
                                                                                                        onClick={() => this.setState(prevState => ({ 
                                                                                                            [`expanded_${data.id}`]: !prevState[`expanded_${data.id}`] 
                                                                                                        }))} 
                                                                                                        className="d-block mt-0 text-primary"
                                                                                                    >
                                                                                                        Show Less
                                                                                                    </Link>
                                                                                                </p>
                                                                                            ) : (
                                                                                                <p>
                                                                                                    {(data.comment).length > 110 
                                                                                                        ? (
                                                                                                            <>
                                                                                                                {(data.comment).substring(0, 110)}
                                                                                                                <Link 
                                                                                                                    to="#" 
                                                                                                                    onClick={() => this.setState({ [`expanded_${data.id}`]: true })} 
                                                                                //   true })} 
                                                                                                                                    className="me-3 text-primary"
                                                                                                                                >
                                                                                                                                    Read More ...
                                                                                                                                </Link>
                                                                                                                            </>
                                                                                                                        ) 
                                                                                                                        : data.comment}
                                                                                                                </p>
                                                                                                            )}
                                                                                                        </>
                                                                                                    )}
                                                                                                </div>
                                                                                                
                                                                                                {/* Hotels and Stays Section */}
                                                                                                {data.hotel ?
                                                                                                    <Row>
                                                                                                        <Col>
                                                                                                            <h4 className="card-title mt-2">{`Hotels and Stays: ${data.hotel.name}`}</h4>
                                                                                                            <div className="scrollmenu d-flex flex-wrap gap-2" id={"scrollmenu-hotel"+index} onWheel={(e) => this.onWheel(e, "scrollmenu-hotel"+index)}>
                                                                                                                {data.hotel.images.map((image, idx) => {
                                                                                                                    return (
                                                                                                                        <Link to="#" className="me-2 text-dark" key={`hotel-img-${idx}`}>
                                                                                                                            <img
                                                                                                                                src={`${BaseUrl}${image.image}`}
                                                                                                                                onClick={() => this.onImageClick(data.hotel.images, data.hotel.name, data.hotel.description)}
                                                                                                                                alt={data.hotel.name}
                                                                                                                                className='rounded-2'
                                                                                                                            />
                                                                                                                            <p className="m-0 mt-1">{(image.name)}</p>
                                                                                                                        </Link>
                                                                                                                    );
                                                                                                                })}    
                                                                                                            </div>
                                                                                                        </Col>
                                                                                                    </Row>
                                                                                                : null}
                                                                                                
                                                                                                {/* Transportation Section */}
                                                                                                {data.vehicle ?
                                                                                                    <Row>
                                                                                                        <h4 className="card-title mt-2 underline-smallfortransport">{`Transportation:`}</h4>
                                                                                                        <div className="d-flex flex-wrap gap-2">
                                                                                                            {data.vehicle.images.map((image, idx) => {
                                                                                                                return (
                                                                                                                    <Link to="#" className="me-2 text-dark" key={`vehicle-img-${idx}`}>
                                                                                                                        <img
                                                                                                                            src={`${BaseUrl}${image.image}`}
                                                                                                                            onClick={() => this.onImageClick(data.vehicle.images, data.vehicle.name, data.vehicle.description)}
                                                                                                                            alt={image.name}
                                                                                                                            className='rounded-2'
                                                                                                                            style={{ width: "100px", objectFit: "cover" }}
                                                                                                                        />
                                                                                                                        <p className="m-0 mt-1" style={{ width: "100px", whiteSpace: "normal", lineHeight: "1.2", wordWrap: "break-word" }}>
                                                                                                                            {(data.vehicle.name)}
                                                                                                                        </p>
                                                                                                                    </Link>
                                                                                                                );
                                                                                                            })}
                                                                                                        </div>
                                                                                                    </Row>
                                                                                                : null}
                                                                                                
                                                                                                {/* Tour End Message */}
                                                                                                {daily_plan.length - 1 === index ?
                                                                                                    <h6 style={{color: "darkgoldenrod", textAlign: "center"}}>
                                                                                                        {`Tour Ends ${itinerary.drop_off_location ? "in " + itinerary.drop_off_location.name : ""} and we hope you will take memories and pleasant experiences.`}
                                                                                                    </h6>
                                                                                                : null}
                                                                                                
                                                                                                {/* Places to Visit Section */}
                                                                                                <Row>
                                                                                                    <Col>
                                                                                                        <h4 className="card-title mt-2 underline-small">{"Places to Visit: "}</h4>
                                                                                                        <div 
                                                                                                            className="scrollmenu pe-2 ps-0" 
                                                                                                            id={"scrollmenu"+index} 
                                                                                                            onWheel={(e) => this.onWheel(e, "scrollmenu"+index)}
                                                                                                            style={{marginTop: '10px'}}
                                                                                                        >
                                                                                                            {(() => {
                                                                                                                const placesToShow = [];
                                                                                                                
                                                                                                                // Add current location
                                                                                                                placesToShow.push(
                                                                                                                    <Link key={`current-${data.current_location.id}`} to="#" className="text-dark">
                                                                                                                        <img
                                                                                                                            src={`${BaseUrl}${data.current_location.image[0].image}`}
                                                                                                                            onClick={() => this.onImageClick(data.current_location.image, data.current_location.name, data.current_location.description)}
                                                                                                                            alt={data.current_location.name}
                                                                                                                            className='rounded-2'
                                                                                                                        />
                                                                                                                        <p>{(data.current_location.name).substring(0,12)}</p>
                                                                                                                    </Link>
                                                                                                                );
                                                                                                                
                                                                                                                // Add to_travel location if it exists
                                                                                                                if (data.to_travel && data.to_travel.image[0]) {
                                                                                                                    placesToShow.unshift(
                                                                                                                        <Link key={`travel-${data.to_travel.id}`} to="#" className="text-dark">
                                                                                                                            <img
                                                                                                                                src={`${BaseUrl}${data.to_travel.image[0].image}`}
                                                                                                                                onClick={() => this.onImageClick(data.to_travel.image, data.to_travel.name, data.to_travel.description)}
                                                                                                                                alt={data.to_travel.name}
                                                                                                                                className='rounded-2'
                                                                                                                            />
                                                                                                                            <p>{(data.to_travel.image[0].name).substring(0,12)}</p>
                                                                                                                        </Link>
                                                                                                                    );
                                                                                                                }
                                                                                                                
                                                                                                                // Add visiting places
                                                                                                                data.visiting_places.forEach(place => {
                                                                                                                    if (place.id !== data.to_travel?.id && place.id !== data.current_location.id && place.image[0]) {
                                                                                                                        placesToShow.unshift(
                                                                                                                            <Link key={`visit-${place.id}`} to="#" className="text-dark">
                                                                                                                                <img
                                                                                                                                    src={`${BaseUrl}${place.image[0].image}`}
                                                                                                                                    onClick={() => this.onImageClick(place.image, place.name, place.description)}
                                                                                                                                    alt={place.name}
                                                                                                                                    className='rounded-2'
                                                                                                                                />
                                                                                                                                <p>{(place.image[0].name)}</p>
                                                                                                                            </Link>
                                                                                                                        );
                                                                                                                    }
                                                                                                                });
                                                                                                                
                                                                                                                // Join places with commas
                                                                                                                return placesToShow.map((place, index) => (
                                                                                                                    <React.Fragment key={`fragment-${index}`}>
                                                                                                                        {place}
                                                                                                                        {index < placesToShow.length - 1 && <span className="me-1">,</span>}
                                                                                                                    </React.Fragment>
                                                                                                                ));
                                                                                                            })()}
                                                                                                        </div>
                                                                                                    </Col>
                                                                                                </Row>
                                                                                                
                                                                                                {/* Activities Section */}
                                                                                                {data.activity.length !== 0 ?
                                                                                                    <Row>
                                                                                                        <h4 className="card-title mt-2 underline-smallfortransport">{`Activities Today: `}</h4>
                                                                                                        <div 
                                                                                                            className="d-flex flex-wrap justify-content-start justify-content-lg-end"
                                                                                                            style={{ maxHeight: '100px', overflowY: 'auto' ,marginTop: '2px'}}
                                                                                                            id={"scrollmenu-activity" + index}
                                                                                                        >
                                                                                                            {[...data.activity].reverse().map((activity, idx) => (
                                                                                                                <span key={activity.id} className="text-dark" style={{ marginRight: '5px' }}>
                                                                                                                    <a
                                                                                                                        href={`/activity/${activity.id}`}
                                                                                                                        target="_blank"
                                                                                                                        rel="noopener noreferrer"
                                                                                                                        style={{ color: 'blue' }}
                                                                                                                    >
                                                                                                                        {activity.name}
                                                                                                                    </a>
                                                                                                                    {idx !== data.activity.length - 1 && ',\u00A0'}
 {/* Add comma except for the last item */}
                                                                                                                </span>
                                                                                                            ))}
                                                                                                        </div>
                                                                                                    </Row>
                                                                                                : null}
                                                                                            </div>
                                                                                        </CardBody>
                                                                                    </Card>
                                                                                </div>
                                                                            </div>
                                                                        ))}
                                                )}
                                                                </div>
                                                            </Col>
                                                        </Row>
                                                        

                                                    </div>
                                                    
                                                    {/* Print-only footer */}
                                                    {print && (
                                                        <div className="print-only print-footer">
                                                            <p>
                                                                {signature?.name} | {signature?.address} | {signature?.website} | Page <span className="print-page-number"></span>
                                                            </p>
                                                        </div>
                                                    )}
                                                </Container>
                                            )
                                }
                                    </div>
                                    
                                ) : (
                                    <div className="d-flex align-items-center justify-content-center min-vh-100">
                                        <Spinner type="grow" className="me-2" color="secondary" />
                                        <Spinner type="grow" className="me-2" color="secondary" />
                                        <Spinner type="grow" className="me-2" color="secondary" />
                                        <Spinner type="grow" className="me-2" color="secondary" />
                                    </div>
                                )}
                            </React.Fragment>
                        );
                    }
                }

                export default TimelineData;